<template>
  <div class="viewer">
    <div class="main">
      <div class="left">
        <!-- <div class="left_content">
          <div @click="sequenceHidden" class="left_listone">
            <span>序列布局</span>
            <i
              :class="
                hidden == true ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <div
            :class="
              hidden == true
                ? 'list_content '
                : 'list_content list_contentactive'
            "
          >
            <div
              :class="['layout', data.clicked ? `focus_bg` : ``]"
              v-for="(data, index) in layouts"
              :key="index"
              @click="changeLayout(index)"
            >
              <img :src="data.url" />
              <p class="nameDcm">{{ data.names }}</p>
            </div>
          </div>
        </div> -->
        <!-- <h3>序列布局:</h3> -->
        <!-- <div class="layouts">
          <div
            :class="['layout', data.clicked ? `focus_bg` : ``]"
            :key="index"
            v-for="(data, index) in layouts"
            @click="changeLayout(index)"
          >
            <img :src="data.url" />
          </div>
        </div> -->
        <div class="left_content">
          <!-- <div v-text="hidden"></div> -->
          <div @click="functionShow" class="left_listone">
            <span>显示功能</span>
            <i
              :class="
                functions == true ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <div :class="functions == true ? 'layouts' : 'layouts layoutsactive'">
            <div
              class="layout_box"
              @mouseover="OverLayou()"
              @mouseleave="LeaveLayou()"
            >
              <el-popover
                popper-class="poppover"
                v-model="lagyouter"
                placement="right"
                trigger="click"
              >
                <div class="squared">
                  <div class="practicing_box">
                    <div
                      @click="onesclick(0)"
                      @mouseover="practicingone(1)"
                      @mouseleave="Leavepracticingone(1)"
                      :class="
                        onelayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(1)"
                      @mouseover="practicingone(2)"
                      @mouseleave="Leavepracticingone(2)"
                      :class="
                        twolayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(2)"
                      @mouseover="practicingone(3)"
                      @mouseleave="Leavepracticingone(3)"
                      :class="
                        sanlayou == true
                          ? 'practicing practicing_one '
                          : 'practicing'
                      "
                    ></div>
                    <!-- 4 -->
                    <div
                      @click="onesclick(41)"
                      @mouseover="practicingone(41)"
                      @mouseleave="Leavepracticingone(41)"
                      :class="
                        siyilayou == true
                          ? 'practicing practicing_one '
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(3)"
                      @mouseover="practicingone(4)"
                      @mouseleave="Leavepracticingone(4)"
                      :class="
                        silayou == true
                          ? 'practicing practicing_one '
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(4)"
                      @mouseover="practicingone(5)"
                      @mouseleave="Leavepracticingone(5)"
                      :class="
                        wulayou == true
                          ? 'practicing practicing_one '
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(5)"
                      @mouseover="practicingone(6)"
                      @mouseleave="Leavepracticingone(6)"
                      :class="
                        liulayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <!-- 8 -->
                    <div
                      @click="onesclick(42)"
                      @mouseover="practicingone(42)"
                      @mouseleave="Leavepracticingone(42)"
                      :class="
                        sierlayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(6)"
                      @mouseover="practicingone(7)"
                      @mouseleave="Leavepracticingone(7)"
                      :class="
                        qilayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(7)"
                      @mouseover="practicingone(8)"
                      @mouseleave="Leavepracticingone(8)"
                      :class="
                        balayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(8)"
                      @mouseover="practicingone(9)"
                      @mouseleave="Leavepracticingone(9)"
                      :class="
                        jiulayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <!-- 12 -->
                    <div
                      @click="onesclick(43)"
                      @mouseover="practicingone(43)"
                      @mouseleave="Leavepracticingone(43)"
                      :class="
                        sisanlayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(9)"
                      @mouseover="practicingone(10)"
                      @mouseleave="Leavepracticingone(10)"
                      :class="
                        shilayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(13)"
                      @mouseover="practicingone(14)"
                      @mouseleave="Leavepracticingone(14)"
                      :class="
                        shisilayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(14)"
                      @mouseover="practicingone(15)"
                      @mouseleave="Leavepracticingone(15)"
                      :class="
                        shiwulayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                    <div
                      @click="onesclick(16)"
                      @mouseover="practicingone(16)"
                      @mouseleave="Leavepracticingone(16)"
                      :class="
                        shiliulayou == true
                          ? 'practicing practicing_one'
                          : 'practicing'
                      "
                    ></div>
                  </div>
                </div>
                <div slot="reference">
                  <img
                    v-if="layoutBox == true"
                    style="width: 25px; height: 25px"
                    src="../resources/images/icon/gggggg_06.png"
                  />
                  <img
                    v-else
                    style="width: 25px; height: 25px"
                    src="../resources/images/icon/rrrr_06.png"
                  />
                  <p class="nameDcm Dcmlayout">布局</p>
                </div>
              </el-popover>
            </div>
            <div
              class="layout"
              v-for="(data, index) in dcmStates"
              :key="index"
              @click="changeDcmState(index)"
              @mouseover="mousedcmStates(index)"
              @mouseleave="LeavedcmStates(index)"
            >
              <img :src="data.url" />
              <p class="nameDcm">{{ data.name }}</p>
            </div>

            <div
              v-for="(item, obj) in baseAction"
              :key="item.name"
              class="normal_action"
            >
              <div
                class="layouter"
                @click="baseActionDown(obj)"
                @mouseover="mouseOver(obj)"
                @mouseleave="mouseLeave(obj)"
                :class="[item.clicked ? `action_blur` : ``]"
              >
                <img
                  :src="item.clicked ? item.activeurl : item.url"
                  :title="item.name"
                />
                <p class="nameDcm">{{ item.names }}</p>
              </div>
            </div>

            <div
              class="Fullscreen"
              @mouseover="OverFullscreen()"
              @mouseleave="LeaveFullscreen()"
            >
              <img
                v-if="screen == true"
                style="
                  width: 25px;
                  height: 25px;
                  margin-top: 5px;
                  margin-bottom: 5px;
                "
                src="../resources/images/icon/rrrr_45.png"
                @click="fullScreen"
              />
              <img
                v-else
                style="
                  width: 25px;
                  height: 25px;
                  margin-top: 5px;
                  margin-bottom: 5px;
                "
                src="../resources/images/icon/rrrr_45.png"
                @click="fullScreen"
              />
              <p class="nameDcm">全屏</p>
            </div>
            <!-- <div class="layouts"> -->
            <div
              :key="data.name"
              class="layout layoutgun"
              v-for="data in dcmLive"
              @click="clickDemopua(focusElementIndex)"
              @mouseover="OverdcmLive()"
              @mouseleave="LeavedcmLive()"
            >
              <img
                style="margin-bottom: 5px; margin-top: -9px"
                :src="data.url"
              />
              <p class="nameDcm">滚动工具</p>
            </div>
            <el-dropdown @command="changeWindow" :hide-on-click="false">
              <div
                @mouseover="dropdown = true"
                @mouseleave="dropdown = false"
                style="height: 55px; margin-top: 5px"
                class="layout Adjustable"
              >
                <img
                  v-if="dropdown == false"
                  src="../resources/images/icon/rrrr_05.png"
                />
                <img
                  v-if="dropdown == true"
                  src="../resources/images/icon/gggggg_05.png"
                />
                <p style="margin-top: 5px" class="nameDcm">调窗</p>
              </div>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item
                  v-for="(item, index) in AdjustableList"
                  :key="index"
                  :command="item"
                >{{ item.name }}</el-dropdown-item
                >
              </el-dropdown-menu>
            </el-dropdown>
            <div
              :key="data.name"
              style="height: 56px"
              class="layout layoutgun"
              v-for="data in dcmLivefree"
              @click="clickQuadrangle"
              @mouseover="OverdcmLivefree()"
              @mouseleave="LeavedcmLivefree()"
            >
              <img
                style="margin-bottom: 5px; margin-top: 0px"
                :src="data.url"
              />
              <p class="nameDcm">四角信息</p>
            </div>
            <div
              :key="data.name"
              style="height: 50px"
              class="layout layoutgun"
              v-for="data in dcmFDJ"
              @click="clickMagnifier"
              @mouseover="OverdcmFDJ()"
              @mouseleave="LeavedcmFDJ()"
            >
              <img
                style="margin-bottom: 5px; margin-top: -5px"
                :src="data.url"
              />
              <p class="nameDcm">放大镜</p>
            </div>
          </div>
        </div>
        <div class="left_content">
          <!-- <div v-text="hidden"></div> -->
          <div @click="measureshow" class="left_listone">
            <span>测量功能</span>
            <i
              :class="
                measure == true ? 'el-icon-caret-bottom' : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <div
            :class="measure == true ? 'layoutss' : 'layoutss layoutsactives'"
          >
            <div
              v-for="(data, index) in canvasAction"
              :key="index"
              class="normal_action"
              @mouseover="OvercanvasAction(index)"
              @mouseleave="LeavecanvasAction(index)"
            >
              <div
                class="layouter"
                @click="canvasActionDown(index)"
                :class="[data.clicked ? `action_blurs` : ``]"
              >
                <img
                  :src="data.clicked ? data.activeurl : data.url"
                  :title="data.name"
                />
                <p class="nameDcm">{{ data.names }}</p>
              </div>
            </div>
          </div>
        </div>
        <div class="left_content">
          <div @click="dimensionalshow" class="left_listone">
            <span>挂片协议</span>
            <i
              :class="
                dimensional == true
                  ? 'el-icon-caret-bottom'
                  : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <a
            :class="
              dimensional == true ? 'layoutss' : 'layoutss layoutsactives'
            "
          >
            <div class="mprstyle" @click="clickHanging">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p1.png"
                alt=""
              />
              <span>3D+2D</span>
            </div>
            <div class="mprstyle" @click="clickHanging2D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p1.png"
                alt=""
              />
              <span>2D</span>
            </div>
            <div class="mprstyle" @click="clickHanging3D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p1.png"
                alt=""
              />
              <span>3D</span>
            </div>
            <div class="mprstyle" @click="clickHanging2D3D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p1.png"
                alt=""
              />
              <span>2D+3D</span>
            </div>
            <div class="mprstyle" @click="clickHangingCC2D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p6.png"
                alt=""
              />
              <span>2D</span>
            </div>
            <div class="mprstyle" @click="clickHangingCC3D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p6.png"
                alt=""
              />
              <span>3D</span>
            </div>
            <div class="mprstyle" @click="clickHangingMLO2D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p7.png"
                alt=""
              />
              <span>2D</span>
            </div>
            <div class="mprstyle" @click="clickHangingMLO3D">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/p7.png"
                alt=""
              />
              <span>3D</span>
            </div>
          </a>
        </div>
        <div class="left_content">
          <div @click="clickAIshow" class="left_listone">
            <span>AI辅助</span>
            <i
              :class="
                AIshow == true
                  ? 'el-icon-caret-bottom'
                  : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <a
            :class="
              AIshow == true ? 'layoutss' : 'layoutss layoutsactives'
            "
          >
            <div class="mprstyle" @click="clickzhongkuai">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/肿块.png"
                alt=""
              />
              <span>肿块</span>
            </div>
            <div class="mprstyle" @click="clicktumor">
              <img
                v-if="mprstyle == false"
                style="width: 25px; height: 25px; padding: 5px"
                src="../resources/images/icon/钙化.png"
                alt=""
              />
              <span>钙化</span>
            </div>







          </a>
        </div>
        <!-- <div class="left_content">
          <div @click="carddimensionalshow" class="left_listone">
            <span>胶片打印</span>
            <i
              :class="
                carddimensional == true
                  ? 'el-icon-caret-bottom'
                  : 'el-icon-caret-top'
              "
            ></i>
          </div>
          <div
            :class="
              carddimensional == true ? 'layoutss' : 'layoutss layoutsactives'
            "
            @click.stop="ClickImageUrlItem"
          >
            <div
              @mouseover="dayinstyle = true"
              @mouseleave="dayinstyle = false"
              v-if="dayinstyle == false"
              class="dayinstyle"
            >
              <img src="../resources/images/icon/dayin.png" alt="" />
              <span>胶片打印</span>
            </div>
            <div
              @mouseover="dayinstyle = true"
              @mouseleave="dayinstyle = false"
              v-if="dayinstyle == true"
              class="dayinstyleactive"
            >
              <img src="../resources/images/icon/dayinactive.png" alt="" />
              <span>胶片打印</span>
            </div>
          </div>
        </div> -->
        <!-- <h3>图像工具:</h3> -->
        <!-- <div class="layouts">
          <div
            :key="index"
            class="layout"
            v-for="(data, index) in dcmStates"
            @click="changeDcmState(index)"
          >
            <img :src="data.url" />
          </div>
        </div> -->
        <!-- <h3>自动播放</h3> -->
        <!-- <div class="layouts">
          <div
            :key="index"
            class="layout"
            v-for="(data, index) in dcmLive"
            @click="clickDemo"
          >
            <img :src="data.url" />
          </div>
        </div> -->
      </div>
      <div class="center">
        <div class="progressBox">
          <el-progress
            :percentage="imageNumber == 1 ? 0 : progressNumber"
          ></el-progress>
        </div>
        <div class="layout">
          <div
            :key="index"
            id="aaa"
            :class="[
              'dcm_layout',
              layoutClass,
              index === focusElementIndex ? `active_layout` : ``,
            ]"
            v-for="(data, index) in 16"
            @click="clickLayout(index, copyList[index].list)"
            @contextmenu.prevent.stop="
              rightClick(index, copyList[index].list, $event)
            "
            @dblclick="shishiClick(index)"
          >
            <div
              :class="Quadrangle == true ? 'leftTop' : 'showQuadrangle'"
              v-if="index < copyList.length && copyList.length > 0"
            >
              <p>姓名：{{ copyList[index].username }}</p>
              <p>年龄：{{ copyList[index].studyAge }}</p>
              <p>性别：{{ copyList[index].gender == "0" ? "男" : "女" }}</p>
              <p>Lat/Pos：{{ copyList[index].seriesDescription }}</p>
            </div>
            <div
              :class="Quadrangle == true ? 'rightTop' : 'showQuadrangle'"
              v-if="index < copyList.length && copyList.length > 0"
            >
              <p>
                {{ copyList[index].times }}
              </p>
              <p>
                {{ copyList[index].seriesDescription }}
              </p>
              <p>
                Imgasd:{{
                  index === focusElementIndex ? imageNumber : ImgNUmber[index]
                }}
              </p>
              <!-- <div>{{index}},{{focusElementIndex}}</div> -->
              <!-- <p>Img:{{ imageNumber }}</p> -->
            </div>

            <div
              :class="Quadrangle == true ? 'bottomRight' : 'showQuadrangle'"
              v-if="index < lists.length && lists.length > 0"
            >
              <p>W:{{ ww }}</p>
              <p>L:{{ wl }}</p>
            </div>
            <div
              @click.stop="clickCard(copyList[index])"
              v-if="index === focusElementIndex && showCard"
              class="center_card"
              :style="{ left: menuLeft + 'px', top: menuTop + 'px' }"
            >
              标记为关键影像
            </div>
          </div>
        </div>
      </div>
      <!-- 右侧 -->
      <div class="right">
        <div class="dcm_count">共有{{ iamgelength }}张图像</div>
        <div class="dcm_load_progress">
          <el-progress
            :text-inside="true"
            :stroke-width="14"
            :percentage="loadSuccessPercent"
            status="success"
          ></el-progress>
        </div>
        <div class="item_dcms">
          <div
            :class="domeindex == index ? 'dcm dcmactive' : 'dcm'"
            v-for="(data, index) in user.seriesList"
            :key="index"
            @click="changeDcm(index)"
          >
            <img v-if="data.list" :src="data.list[0].thumbImagePath" />
            <div class="box_type">
              <p v-if="data.list" class="title titleover">
                序列:{{ data.seriesNumber }}
              </p>
              <p v-if="data.list" class="title titleover">
                图数:{{ data.list.length }}
              </p>
              <p class="title titleover">类型:{{ user.studyModality }}</p>
            </div>
            <!-- <p>{{data.seriesNumber}}</p> -->
          </div>
        </div>
      </div>
    </div>
    <el-dialog
      top="15vh"
      :visible.sync="dialogFormVisible"
      width="20%"
      :close-on-click-modal="false"
    >
      <el-form :model="form" ref="form">
        <el-form-item prop="w" label="窗宽:" :label-width="formLabelWidth">
          <el-input
            type="number"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>65535)value=65535;if(value<=0)value=null"
            placeholder="请输入窗宽"
            v-model="form.w"
            autocomplete="off"
          ></el-input>
        </el-form-item>
        <el-form-item prop="l" label="窗位:" :label-width="formLabelWidth">
          <el-input
            type="number"
            placeholder="请输入窗位"
            oninput="if(!/^[0-9]+$/.test(value)) value=value.replace(/\D/g,'');if(value>65535)value=65535;if(value<=0)value=null"
            v-model="form.l"
            autocomplete="off"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="exports">确 定</el-button>
      </div>
    </el-dialog>
    <!-- 胶片打印弹窗 -->
    <el-dialog width="50%" class="carBoxBox" :visible.sync="CardFormVisible">
      <el-dialog
        width="15%"
        title="选择布局"
        :visible.sync="innerVisible"
        append-to-body
      >
        <div class="cardLayoutBoxs">
          <div
            class="cardItembox"
            :class="card1 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(1)"
            @mouseleave="cardOver(1)"
            @click="Card22(1)"
          ></div>
          <div
            class="cardItembox"
            :class="card2 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(2)"
            @mouseleave="cardOver(2)"
            @click="Card22(2)"
          ></div>
          <div
            class="cardItembox"
            :class="card3 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(3)"
            @mouseleave="cardOver(3)"
            @click="Card22(3)"
          ></div>
          <div
            class="cardItembox"
            :class="card4 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(4)"
            @mouseleave="cardOver(4)"
            @click="Card22(4)"
          ></div>
          <div
            class="cardItembox"
            :class="card5 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(5)"
            @mouseleave="cardOver(5)"
            @click="Card22(5)"
          ></div>
          <div
            class="cardItembox"
            :class="card6 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(6)"
            @mouseleave="cardOver(6)"
            @click="Card22(6)"
          ></div>
          <div
            class="cardItembox"
            :class="card7 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(7)"
            @mouseleave="cardOver(7)"
            @click="Card22(7)"
          ></div>
          <div
            class="cardItembox"
            :class="card8 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(8)"
            @mouseleave="cardOver(8)"
            @click="Card22(8)"
          ></div>
          <div
            class="cardItembox"
            :class="card9 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(9)"
            @mouseleave="cardOver(9)"
            @click="Card22(9)"
          ></div>
          <div
            class="cardItembox"
            :class="card10 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(10)"
            @mouseleave="cardOver(10)"
            @click="Card22(10)"
          ></div>
          <div
            class="cardItembox"
            :class="card11 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(11)"
            @mouseleave="cardOver(11)"
            @click="Card22(11)"
          ></div>
          <div
            class="cardItembox"
            :class="card12 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(12)"
            @mouseleave="cardOver(12)"
            @click="Card22(12)"
          ></div>
          <div
            class="cardItembox"
            :class="card13 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(13)"
            @mouseleave="cardOver(13)"
            @click="Card22(13)"
          ></div>
          <div
            class="cardItembox"
            :class="card14 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(14)"
            @mouseleave="cardOver(14)"
            @click="Card22(14)"
          ></div>
          <div
            class="cardItembox"
            :class="card15 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(15)"
            @mouseleave="cardOver(15)"
            @click="Card22(15)"
          ></div>
          <div
            class="cardItembox"
            :class="card16 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(16)"
            @mouseleave="cardOver(16)"
            @click="Card22(16)"
          ></div>
          <div
            class="cardItembox"
            :class="card17 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(17)"
            @mouseleave="cardOver(17)"
            @click="Card22(17)"
          ></div>
          <div
            class="cardItembox"
            :class="card18 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(18)"
            @mouseleave="cardOver(18)"
            @click="Card22(18)"
          ></div>
          <div
            class="cardItembox"
            :class="card19 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(19)"
            @mouseleave="cardOver(19)"
            @click="Card22(19)"
          ></div>
          <div
            class="cardItembox"
            :class="card20 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(20)"
            @mouseleave="cardOver(20)"
            @click="Card22(20)"
          ></div>
          <div
            class="cardItembox"
            :class="card21 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(21)"
            @mouseleave="cardOver(21)"
            @click="Card22(21)"
          ></div>
          <div
            class="cardItembox"
            :class="card22 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(22)"
            @mouseleave="cardOver(22)"
            @click="Card22(22)"
          ></div>
          <div
            class="cardItembox"
            :class="card23 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(23)"
            @mouseleave="cardOver(23)"
            @click="Card22(23)"
          ></div>
          <div
            class="cardItembox"
            :class="card24 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(24)"
            @mouseleave="cardOver(24)"
            @click="Card22(24)"
          ></div>
          <div
            class="cardItembox"
            :class="card25 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(25)"
            @mouseleave="cardOver(25)"
            @click="Card22(25)"
          ></div>
          <div
            class="cardItembox"
            :class="card26 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(26)"
            @mouseleave="cardOver(26)"
            @click="Card22(26)"
          ></div>
          <div
            class="cardItembox"
            :class="card27 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(27)"
            @mouseleave="cardOver(27)"
            @click="Card22(27)"
          ></div>
          <div
            class="cardItembox"
            :class="card28 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(28)"
            @mouseleave="cardOver(28)"
            @click="Card22(28)"
          ></div>
          <div
            class="cardItembox"
            :class="card29 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(29)"
            @mouseleave="cardOver(29)"
            @click="Card22(29)"
          ></div>
          <div
            class="cardItembox"
            :class="card30 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(30)"
            @mouseleave="cardOver(30)"
            @click="Card22(30)"
          ></div>
          <div
            class="cardItembox"
            :class="card31 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(31)"
            @mouseleave="cardOver(31)"
            @click="Card22(31)"
          ></div>
          <div
            class="cardItembox"
            :class="card32 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(32)"
            @mouseleave="cardOver(32)"
            @click="Card22(32)"
          ></div>
          <div
            class="cardItembox"
            :class="card33 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(33)"
            @mouseleave="cardOver(33)"
            @click="Card22(33)"
          ></div>
          <div
            class="cardItembox"
            :class="card34 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(34)"
            @mouseleave="cardOver(34)"
            @click="Card22(34)"
          ></div>
          <div
            class="cardItembox"
            :class="card35 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(35)"
            @mouseleave="cardOver(35)"
            @click="Card22(35)"
          ></div>
          <div
            class="cardItembox"
            :class="card36 == true ? 'practicing practicing_one' : 'practicing'"
            @mouseover="cardHover(36)"
            @mouseleave="cardOver(36)"
            @click="Card22(36)"
          ></div>
        </div>
      </el-dialog>
      <div class="cardtool">
        <div class="cardtool_left">
          <div @click="clickpreservation">保存</div>
          <div @click="innerVisible = true">布局</div>
          <div @click="baseActionDown(1)">平移</div>
          <div @click="baseActionDown(0)">缩放</div>
          <div @click="canvasActionDown(0)">测量</div>
          <div @click="clearCanvasToolscard()">清除</div>
        </div>
        <div @click="CardFormVisible = false" class="cardtool_right">X</div>
      </div>
      <div class="cardLayoutBox">
        <div
          id="aabb"
          style="width: calc(100% - 140px); height: 400px; overflow: hidden"
        >
          <div
            :class="[
              'cardDcm_layout',
              layoutClassCard,
              index === focusElementIndexCard ? `active_layout` : ``,
            ]"
            v-for="(data, index) in 36"
            :key="index"
            @click.stop="clickCardLayout(index)"
            @contextmenu.prevent.stop="rightClickcard(index, $event)"
          >
            <div
              v-if="
                index < copyarr1.length &&
                copyarr1.length > 0 &&
                copyarr1[index] != ''
              "
              class="cardCanvasLeft"
            >
              <!-- 弹窗四角信息 -->
              <p>姓名:{{ copyarr1[index].username }}</p>
              <p>年龄：{{ copyarr1[index].studyAge }}</p>
              <p>性别：{{ copyarr1[index].gender == "0" ? "男" : "女" }}</p>
              <p>Lat/Pos：{{ copyarr1[index].seriesDescription }}</p>
              <!-- <p>姓名:{{copyList[index].username}}</p> -->
            </div>
            <div
              v-if="
                index < copyarr1.length &&
                copyarr1.length > 0 &&
                copyarr1[index] != ''
              "
              class="cardCanvasRight"
            >
              <!-- 弹窗四角信息 -->
              <p>{{ copyarr1[index].times }}</p>
              <p>{{ copyarr1[index].seriesDescription }}</p>
              <!-- <p>姓名:{{copyList[index].username}}</p> -->
            </div>
            <div
              v-if="
                index < copyarr1.length &&
                copyarr1.length > 0 &&
                copyarr1[index] != ''
              "
              class="cardCanvasRightBottom"
            >
              <!-- 弹窗四角信息 -->
              <p>W:{{ copyarr1[index].windowWidth }}</p>
              <p>L:{{ copyarr1[index].windowCenter }}</p>
              <!-- <p>姓名:{{copyList[index].username}}</p> -->
            </div>
            <div
              @click="deleteCardItem(index)"
              v-if="index === focusElementIndexCard && showCardcard"
              class="center_card"
              :style="{ left: menuLeftcard + 'px', top: menuTopcard + 'px' }"
            >
              删除影像
            </div>
          </div>
        </div>
        <div class="comUrlPath">
          <div
            :class="
              domeindexCard == index ? 'comUrlList dcmactive' : 'comUrlList'
            "
            v-for="(data, index) in arr1"
            :key="index"
            @click="changeDcmCard(index)"
          >
            <div class="leftCom">
              <img
                style="width: 100%; height: 100%; object-fit: contain"
                :src="data.thumbImagePath"
                alt=""
              />
            </div>
            <div class="rightCom">
              <p>序列:{{ data.seriesNumber }}</p>
            </div>
          </div>
        </div>
      </div>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button @click="CardFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="CardFormVisible = false"
          >确 定</el-button
        >
      </div> -->
    </el-dialog>
  </div>
</template>
<script>
import * as cornerstone from "cornerstone-core";
import * as dicomParser from "dicom-parser";
import * as cornerstoneMath from "cornerstone-math";
import * as cornerstoneTools from "cornerstone-tools";
import Hammer from "hammerjs";

var config = {
  maxWebWorkers: navigator.hardwareConcurrency || 16,
  startWebWorkersOnDemand: true,
  taskConfiguration: {
    decodeTask: {
      initializeCodecsOnStartup: false,
      usePDFJS: false,
    },
    sleepTask: {
      sleepTime: 3000,
    },
  },
};
// cornerstoneWADOImageLoader.webWorkerManager.initialize(config);
cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
cornerstoneWADOImageLoader.external.cornerstoneMath = cornerstoneMath;

cornerstoneTools.external.cornerstone = cornerstone;
cornerstoneTools.external.Hammer = Hammer;
cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
cornerstoneTools.init({ showSVGCursors: true });

export default {
  name: "viewer",
  data() {
    return {
      pointMarkRCC:[],
      pointMarkRMLO:[],
      pointMarkLCC:[],
      pointMark:[],
      newarray:[],
      newarrayLCC:[],
      newarrayRMLO:[],
      newarrayRCC:[],
      colordian:false,
      colorquan:false,
      progressNumber: "",
      copyUserList: [],
      formData: {
        studyId: "",
        options: {
          width: "1",
          height: "1",
        },
        filmsId: [],
      },
      innerVisible: false,
      Quadrangle: true,
      copyList: [],
      content: ["上传头像", "修改资料", "退出账号", "在线反馈"],
      sty: {
        top: "22px",
        left: "33px",
      },
      ImgNUmber: [],
      menuLeft: "",
      menuTop: "",
      menuLeftcard: "",
      menuTopcard: "",
      CardFormVisible: false,
      arr1: [],
      cardList: [],
      showCard: false,
      showCardcard: false,
      responseList: [],
      lagyouter: false,
      sanlayou: false,
      sisanlayou: false,
      silayou: false,
      wulayou: false,
      sierlayou: false,
      successLoding: "",
      liulayou: false,
      shiliulayou: false,
      siyilayou: false,
      qilayou: false,
      balayou: false,
      jiulayou: false,
      copyarr1: [],
      shilayou: false,
      shisilayou: false,
      shiwulayou: false,
      onelayou: false,
      card1: false,
      card2: false,
      card3: false,
      card4: false,
      card5: false,
      card6: false,
      card7: false,
      card8: false,
      card9: false,
      card10: false,
      card11: false,
      card12: false,
      card13: false,
      card14: false,
      card15: false,
      card16: false,
      card17: false,
      card18: false,
      card19: false,
      card20: false,
      card21: false,
      card22: false,
      card23: false,
      card24: false,
      card25: false,
      card26: false,
      card27: false,
      card28: false,
      card29: false,
      card30: false,
      card31: false,
      card32: false,
      card33: false,
      card34: false,
      card35: false,
      card36: false,
      twolayou: false,
      CardItemListtab: [],
      layoutBox: false,
      mprstyle: false,
      dayinstyle: false,
      dropdown: false,
      screen: false,
      activeim: "",
      tokens: "",
      ww: "",
      wl: "",
      formLabelWidth: "",
      form: {
        l: "",
        w: "",
      },
      dialogFormVisible: false,
      AdjustableList: [
        {
          name: "初始值",
          w: 161,
          l: -920,
        },
        {
          name: "全窗",
          w: 193,
          l: -915,
        },
        {
          name: "头颅",
          w: 100,
          l: 40,
        },
        {
          name: "骨骼",
          w: 1000,
          l: 400,
        },
        {
          name: "鼻咽",
          w: 300,
          l: 40,
        },
        {
          name: "胸部",
          w: 400,
          l: 40,
        },
        {
          name: "肺部",
          w: 1500,
          l: -700,
        },
        {
          name: "肝脾",
          w: 150,
          l: 40,
        },
        {
          name: "肾脏",
          w: 250,
          l: 30,
        },
        {
          name: "胰腺",
          w: 320,
          l: 35,
        },
        {
          name: "四肢",
          w: 300,
          l: 40,
        },
        {
          name: "自定义",
        },
      ],
      imageNumber: 1,
      measure: false,
      dimensional: false,
      AIshow: false,
      carddimensional: false,
      functions: true,
      hidden: false,
      iamgelength: "",
      domeindex: "0",
      domeindexCard: "0",
      numImagesLoaded: 0,
      imageIds: [],
      liss: "",
      lisstime: "",
      times: "",
      latPos: "",
      lengthh: "",
      user: {
        username: "",
        seriesList: [
          {
            username: "",
          },
        ],
      },
      lists: [],
      ids: "",
      element: null,
      layouts: [
        {
          tag: 1,
          url: require("../resources/images/icon/icon_juxing.png"),
          clicked: true,
          names: "一宫格",
        },
        {
          tag: 2,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向布局",
        },
        {
          tag: 2.1,
          url: require("../resources/images/icon/icon_hengju.png"),
          clicked: false,
          names: "纵向布局",
        },
        {
          tag: 4,
          url: require("../resources/images/icon/icon_tianju.png"),
          clicked: false,
          names: "四宫格",
        },
        {
          tag: 9,
          url: require("../resources/images/icon/icon_shuangju.png"),
          clicked: false,
          names: "九宫格",
        },
        {
          tag: 11,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向三格",
        },
        {
          tag: 66,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向六格",
        },
        {
          tag: 22,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "纵向3格",
        },
        {
          tag: 88,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "纵向6格",
        },
        {
          tag: 14,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "纵向4格",
        },
        {
          tag: 34,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "纵向12宫格",
        },
        {
          tag: 44,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "纵向14宫格",
        },
        {
          tag: 41,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向4宫格",
        },
        {
          tag: 42,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向8宫格",
        },
        {
          tag: 43,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "横向12宫格",
        },
        {
          tag: 16,
          url: require("../resources/images/icon/icon_shuju.png"),
          clicked: false,
          names: "16宫格",
        },
      ],
      loopCount: "",
      layoutClass: "auto_layout4",
      layoutClassCard: "auto_layout4",
      dcmStates: [
        {
          url: require("../resources/images/icon/rrrr_15.png"),
          copyurl: require("../resources/images/icon/rrrr_15.png"),
          name: "右转90°",
          activeurl: require("../resources/images/icon/gggggg_15.png"),
        },
        {
          url: require("../resources/images/icon/rrrr_14.png"),
          copyurl: require("../resources/images/icon/rrrr_14.png"),
          name: "左转90°",
          activeurl: require("../resources/images/icon/gggggg_14.png"),
        },
        {
          url: require("../resources/images/icon/rrrr_12.png"),
          copyurl: require("../resources/images/icon/rrrr_12.png"),
          name: "镜像翻转",
          activeurl: require("../resources/images/icon/gggggg_12.png"),
        },
        {
          url: require("../resources/images/icon/rrrr_13.png"),
          copyurl: require("../resources/images/icon/rrrr_13.png"),
          name: "倒置翻转",
          activeurl: require("../resources/images/icon/gggggg_13.png"),
        },
        {
          url: require("../resources/images/icon/rrrr_47.png"),
          copyurl: require("../resources/images/icon/rrrr_47.png"),
          name: "反色",
          activeurl: require("../resources/images/icon/gggggg_43.png"),
        },
      ],
      dcmLive: [
        {
          url: require("../resources/images/icon/rrrr_17.png"),
          copyurl: require("../resources/images/icon/rrrr_17.png"),
          activeurl: require("../resources/images/icon/gggggg_16.png"),
        },
      ],
      dcmLivefree: [
        {
          url: require("../resources/images/icon/xinxi.png"),
          copyurl: require("../resources/images/icon/xinxi.png"),
          activeurl: require("../resources/images/icon/xinxiactive.png"),
        },
      ],
      dcmFDJ: [
        {
          url: require("../resources/images/icon/fangdajing.png"),
          copyurl: require("../resources/images/icon/fangdajing.png"),
          activeurl: require("../resources/images/icon/fangdajingactive.png"),
        },
      ],
      tempFiles: [
        {
          name: "陈蕊",
          age: "032Y",
          sex: "女",
          studyTime: "2021-06-30 12:12:12",
          type: "L CC",
          thumbnail: require("../resources/images/demo/real1.jpg"),
          url: "http://218.78.27.11:812/real1_names_compress/real1.dcm",
        },
        {
          name: "陈蕊",
          age: "032Y",
          sex: "女",
          studyTime: "2021-06-30 12:12:12",
          type: "L CC",
          thumbnail: require("../resources/images/demo/real2.jpg"),
          url: "http://218.78.27.11:812/real1_names_compress/real2.dcm",
        },
        {
          name: "陈蕊",
          age: "032Y",
          sex: "女",
          studyTime: "2021-06-30 12:12:12",
          type: "L CC",
          thumbnail: require("../resources/images/demo/real3.jpg"),
          url: "http://218.78.27.11:812/real1_names_compress/real3.dcm",
        },
        {
          name: "陈蕊",
          age: "032Y",
          sex: "女",
          studyTime: "2021-06-30 12:12:12",
          type: "L CC",
          thumbnail: require("../resources/images/demo/real4.jpg"),
          url: "http://218.78.27.11:812/real1_names_compress/real4.dcm",
        },
        {
          name: "陈蕊",
          age: "032Y",
          sex: "女",
          studyTime: "2021-06-30 12:12:12",
          type: "L CC",
          thumbnail: require("../resources/images/demo/real4.jpg"),
          url: "http://218.78.27.11:812/real1_names_compress/real5.dcm",
        },
        // {
        //   name: "陈蕊",
        //   age: "032Y",
        //   sex: "女",
        //   studyTime: "2021-06-30 12:12:12",
        //   type: "L CC",
        //   thumbnail: require("../resources/images/demo/real4.jpg"),
        //   url: "http://218.78.27.11:812/real1_names_compress/real6.dcm",
        // },
        // {
        //   name: "陈蕊",
        //   age: "032Y",
        //   sex: "女",
        //   studyTime: "2021-06-30 12:12:12",
        //   type: "L CC",
        //   thumbnail: require("../resources/images/demo/real4.jpg"),
        //   url: "http://218.78.27.11:812/real1_names_compress/real7.dcm",
        // },
      ],
      baseAction: [
        {
          tag: "zoom",
          name: "图像放缩(Z)",
          clicked: false,
          url: require("../resources/images/icon/rrrr_03.png"),
          copyurl: require("../resources/images/icon/rrrr_03.png"),
          names: "缩放",
          activeurl: require("../resources/images/icon/gggggg_03.png"),
        },
        {
          tag: "move",
          name: "图像平移(P)",
          clicked: false,
          url: require("../resources/images/icon/rrrr_02.png"),
          copyurl: require("../resources/images/icon/rrrr_02.png"),
          names: "平移",
          activeurl: require("../resources/images/icon/gggggg_02.png"),
        },
        {
          tag: "wwwc",
          name: "调节窗宽窗位(W)",
          clicked: false,
          url: require("../resources/images/icon/rrrr_05.png"),
          copyurl: require("../resources/images/icon/rrrr_05.png"),
          names: "窗宽窗位",
          activeurl: require("../resources/images/icon/gggggg_05.png"),
        },
        {
          tag: "resver",
          name: "复位",
          clicked: false,
          url: require("../resources/images/icon/rrrr_19.png"),
          copyurl: require("../resources/images/icon/rrrr_19.png"),
          names: "复位",
          activeurl: require("../resources/images/icon/gggggg_18.png"),
        },
      ],
      canvasAction: [
        {
          tag: "length",
          name: "长度(L)",
          clicked: false,
          url: require("../resources/images/icon/rrrr_25.png"),
          copyurl: require("../resources/images/icon/rrrr_25.png"),
          names: "长度测量",
          activeurl: require("../resources/images/icon/gggggg_24.png"),
        },
        {
          tag: "rectangle",
          name: "矩形(R)",
          clicked: false,
          url: require("../resources/images/icon/rrrr_26.png"),
          copyurl: require("../resources/images/icon/rrrr_26.png"),
          names: "矩形测量",
          activeurl: require("../resources/images/icon/gggggg_25.png"),
        },
        {
          tag: "freehandRoi",
          name: "动态框",
          clicked: false,
          url: require("../resources/images/icon/rrrr_42.png"),
          copyurl: require("../resources/images/icon/rrrr_42.png"),
          names: "曲线测量",
          activeurl: require("../resources/images/icon/gggggg_40.png"),
        },
        {
          tag: "angle",
          name: "角度",
          clicked: false,
          url: require("../resources/images/icon/rrrr_28.png"),
          copyurl: require("../resources/images/icon/rrrr_28.png"),
          names: "角度测量",
          activeurl: require("../resources/images/icon/gggggg_27.png"),
        },
        {
          tag: "ellipse",
          name: "椭圆",
          clicked: false,
          url: require("../resources/images/icon/rrrr_27.png"),
          copyurl: require("../resources/images/icon/rrrr_27.png"),
          names: "椭圆测量",
          activeurl: require("../resources/images/icon/gggggg_26.png"),
        },
        {
          tag: "cross",
          name: "十字线",
          clicked: false,
          url: require("../resources/images/icon/rrrr_29.png"),
          copyurl: require("../resources/images/icon/rrrr_29.png"),
          names: "十字测量",
          activeurl: require("../resources/images/icon/gggggg_28.png"),
        },
        /*					{
											tag: 'back',
											name: '删除上一个',
											clicked: false,
											url: require('../resources/images/icon/icon_chexiao.png')
										},*/
        {
          tag: "clear",
          name: "删除所有",
          clicked: false,
          url: require("../resources/images/icon/rrrr_34.png"),
          copyurl: require("../resources/images/icon/rrrr_34.png"),
          activeurl: require("../resources/images/icon/gggggg_32.png"),
          names: "清除",
        },
      ],
      canvasTools: [
        "Length",
        "RectangleRoi",
        "Angle",
        "EllipticalRoi",
        "Bidirectional",
        "FreehandRoi",
      ],
      layoutCount: 1,
      focusElementIndex: 0,
      focusElementIndexCard: 0,
      itemElementList: [],
      loadSuccessPercent: 0,
    };
  },
  created() {
    console.log("window.screenX", window.screen.availWidth);
    console.log("window.screenY", window.screen.availHeight);
    this.tokens = sessionStorage.getItem("token");
    console.log();
    this.ids = this.$route.query.userId;
    this.formData.studyId = this.ids;
    //跳转放大
    if (window.screen.availHeight > window.screen.availWidth) {
      this.$router.push({
        path: "/reportenlarge",
        query: {
          userId: this.ids,
        },
      });
    }
    this.tokens = sessionStorage.getItem("token");
    console.log();
    this.ids = this.$route.query.userId;
    this.formData.studyId = this.ids;
    this.focusElementIndex = 0;
    this.$http
      .get(
        this.GLOBAL.BASE_URL + "v1/study/printdata/" +
        this.ids +
        "?token=" +
        sessionStorage.getItem("token")
      )
      .then((response) => {
        // console.log(response);
        this.successLoding = response.data.success;
        this.responseList = response.data.data.list;
        this.dataList = response.data.data;
        this.getStudyInfo();
        // response.data.data.list
      })
      .catch((err) => {
        this.getStudyInfo();
        console.error(err);
      });
    // this.changeWindow(90,35)


  },
  mounted() {
    window.oncontextmenu = function (e) {
      e.preventDefault();
    };
  },
  methods: {
    onImageRenderedzhongkuaiclear(e){
      const eventData = e.detail;
      const ctx = eventData.canvasContext;
      // ctx.clearRect(0,0,10000,10000);
      // ctx.beginPath();
      // ctx.clearRect(0,0,10000,10000);
      // ctx.beginPath();
    },
    clickzhongkuai(){
      try{

        console.error('this.colorquan',this.colorquan);
        if(this.colorquan == true){
          //隐藏点
          // alert(1);
          // this.colorquan = false;
          this.contextonImageRenderedzhongkuai.clearRect(0,0,10000,10000);
          this.contextonImageRenderedzhongkuai.beginPath();
          for (let index = 0; index < this.copyList.length; index++) {
            const element = this.copyList[index];
            if(element.seriesDescription == 'R CC'){
              this.itemElementList[index].removeEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiRCC
              );
            }
            if(element.seriesDescription == 'R MLO'){
              this.itemElementList[index].removeEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiRMLO
              );
            }
            if(element.seriesDescription == 'L MLO'){
              this.itemElementList[index].removeEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuai
              );
            }
            if(element.seriesDescription == 'L CC'){
              this.itemElementList[index].removeEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiLCC
              );
            }
          }

          //     this.itemElementList[3].addEventListener(
          //   "cornerstoneimagerendered",
          //   this.onImageRenderedLCC
          // );
          //    this.itemElementList[2].addEventListener(
          //   "cornerstoneimagerendered",
          //   this.onImageRenderedLCC
          // );
          this.colorquan = false
          setTimeout(() => {
            // this.precess();
            this.clearCanvasToolsindex(3)
            this.clearCanvasToolsindex(2)
            this.clearCanvasToolsindex(1)
            this.clearCanvasToolsindex(0)
          }, 100);
        }else {
          for (let index = 0; index < this.copyList.length; index++) {
            const element = this.copyList[index];
            if(element.seriesDescription == 'R CC'){
              this.itemElementList[index].addEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiRCC
              );
            }
            if(element.seriesDescription == 'R MLO'){
              this.itemElementList[index].addEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiRMLO
              );
            }
            if(element.seriesDescription == 'L MLO'){
              this.itemElementList[index].addEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuai
              );
            }
            if(element.seriesDescription == 'L CC'){
              this.itemElementList[index].addEventListener(
                "cornerstoneimagerendered",
                this.onImageRenderedzhongkuaiLCC
              );
            }
          }
          this.colorquan = true
          setTimeout(() => {
            this.clearCanvasToolsindex(0)
            this.clearCanvasToolsindex(1)
            this.clearCanvasToolsindex(2)
            this.clearCanvasToolsindex(3)
          }, 1000);
        }
      }catch (e) {
        console.log("clickzhongkuai异常",e);
      }
    },
    clicktumor(){
      if(this.colordian == true){
        //隐藏点
        // alert(1);
        // this.colordian = false;
        for (let index = 0; index < this.copyList.length; index++) {
          const element = this.copyList[index];
          // console.error('element',element);
          // console.error('index',index);
          if(element.seriesDescription == 'R CC'){
            console.error('indexRCC',index);
            this.itemElementList[index].removeEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedRCC
            );
          }
          if(element.seriesDescription == 'R MLO'){
            this.itemElementList[index].removeEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedRMLO
            );
          }
          if(element.seriesDescription == 'L MLO'){
            this.itemElementList[index].removeEventListener(
              "cornerstoneimagerendered",
              this.onImageRendered
            );
          }
          if(element.seriesDescription == 'L CC'){
            this.itemElementList[index].removeEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedLCC
            );
          }
        }
        this.colordian = false

        //     this.itemElementList[3].addEventListener(
        //   "cornerstoneimagerendered",
        //   this.onImageRenderedLCC
        // );
        //    this.itemElementList[2].addEventListener(
        //   "cornerstoneimagerendered",
        //   this.onImageRenderedLCC
        // );
        setTimeout(() => {
          // this.precess();
          this.clearCanvasToolsindex(3)
          this.clearCanvasToolsindex(2)
          this.clearCanvasToolsindex(1)
          this.clearCanvasToolsindex(0)
        }, 100);
      }else {
        for (let index = 0; index < this.copyList.length; index++) {
          const element = this.copyList[index];
          // console.error('element',element);
          // console.error('index',index);
          if(element.seriesDescription == 'R CC'){
            console.error('indexRCC',index);
            this.itemElementList[index].addEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedRCC
            );
          }
          if(element.seriesDescription == 'R MLO'){
            this.itemElementList[index].addEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedRMLO
            );
          }
          if(element.seriesDescription == 'L MLO'){
            this.itemElementList[index].addEventListener(
              "cornerstoneimagerendered",
              this.onImageRendered
            );
          }
          if(element.seriesDescription == 'L CC'){
            this.itemElementList[index].addEventListener(
              "cornerstoneimagerendered",
              this.onImageRenderedLCC
            );
          }
        }
        this.colordian = true
        setTimeout(() => {
          // this.precess();
          this.clearCanvasToolsindex(0)
          this.clearCanvasToolsindex(1)
          this.clearCanvasToolsindex(2)
          this.clearCanvasToolsindex(3)
        }, 100);
      }
    },
    drawPoint(context, x, y, color) {
      // console.log('context',context)
      context.beginPath();
      context.fillStyle = color;
      context.strokeStyle = color;
      context.arc(x, y, 2, 0, Math.PI * 2, true);
      context.closePath();
      context.fill();
    },



    polygon(poly, context) {
      // context.clearRect(0,0,9999,9999);
      // context.fillStyle = '#00000000';
      context.beginPath();
      context.strokeStyle = "yellow";
      context.lineWidth = 10;
      context.moveTo(poly[0], poly[1]);

      for (var i = 2; i < poly.length; i += 2) {
        context.lineTo(poly[i], poly[i + 1]);
        // console.log(poly[i], poly[i + 1]);
      }
      // context.fill();
      // context.stroke();
      // context.save();
      context.stroke();
      context.closePath();
      // context.clearRect();
      // context.beginPath();
    },
    drawLine(context, x1, y1, x2, y2, color, width) {

      // console.error('context',context);
      // console.error('x1',x1);
      // console.error('y1',y1);
      // console.error('x2',x2);
      // console.error('color',color);
      // console.error('width',width);
      context.beginPath();
      context.lineWidth = width;
      // context.fillStyle = color;
      context.strokeStyle = color;
      context.moveTo(x1, y1);
      context.lineTo(x2, y2);
      context.closePath();
      context.stroke();
    },
    clickHanging() {
      this.changeLayout(3);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (
          this.user.seriesList[i].seriesDescription ==
          "R MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(0,i,this.user.seriesList);
          //  this.swapArrData(1,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(1,i,this.user.seriesList);
          // this.swapArrData(0,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "R CC") {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[2] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L CC") {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[3] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
        cornerstone.reset(this.itemElementList[2]);
        cornerstone.reset(this.itemElementList[3]);
      }, 100);
    },
    clickHanging2D() {
      this.changeLayout(3);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (this.user.seriesList[i].seriesDescription == "R MLO") {
          // this.swapArrData(0,i,this.user.seriesList);
          //  this.swapArrData(1,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L MLO") {
          // this.swapArrData(1,i,this.user.seriesList);
          // this.swapArrData(0,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "R CC") {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[2] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L CC") {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[3] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
        cornerstone.reset(this.itemElementList[2]);
        cornerstone.reset(this.itemElementList[3]);
      }, 100);
    },
    clickHanging3D() {
      this.changeLayout(3);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (
          this.user.seriesList[i].seriesDescription ==
          "R MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(0,i,this.user.seriesList);
          //  this.swapArrData(1,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(1,i,this.user.seriesList);
          // this.swapArrData(0,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "R CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[2] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[3] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
        cornerstone.reset(this.itemElementList[2]);
        cornerstone.reset(this.itemElementList[3]);
      }, 100);
    },
    clickHanging2D3D() {
      this.changeLayout(3);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (this.user.seriesList[i].seriesDescription == "R MLO") {
          // this.swapArrData(0,i,this.user.seriesList);
          //  this.swapArrData(1,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L MLO") {
          // this.swapArrData(1,i,this.user.seriesList);
          // this.swapArrData(0,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "R CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[2] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[3] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
        cornerstone.reset(this.itemElementList[2]);
        cornerstone.reset(this.itemElementList[3]);
      }, 100);
    },
    clickHangingCC2D() {
      this.changeLayout(1);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (this.user.seriesList[i].seriesDescription == "R CC") {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L CC") {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
      }, 100);
    },
    clickHangingCC3D() {
      this.changeLayout(1);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (
          this.user.seriesList[i].seriesDescription ==
          "R CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L CC Tomosynthesis Reconstruction CT Image"
        ) {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
      }, 100);
    },
    clickHangingMLO2D() {
      this.changeLayout(1);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (this.user.seriesList[i].seriesDescription == "R MLO") {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (this.user.seriesList[i].seriesDescription == "L MLO") {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
      }, 100);
    },
    clickHangingMLO3D() {
      this.changeLayout(1);
      var arrs = [];
      // this.copyList = this.user.seriesList;
      for (let i = 0; i < this.user.seriesList.length; i++) {
        if (
          this.user.seriesList[i].seriesDescription ==
          "R MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(2,i,this.user.seriesList);
          // this.swapArrData(3,i,this.copyList);
          this.copyList[0] = this.user.seriesList[i];
        }
        if (
          this.user.seriesList[i].seriesDescription ==
          "L MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(3,i,this.user.seriesList);
          // this.swapArrData(2,i,this.copyList);
          this.copyList[1] = this.user.seriesList[i];
        }
        console.error("this.copyList", this.copyList);
        for (let i = 0; i < this.copyList.length; i++) {
          this.copyList[i].list.map((item) => {
            arrs.push("wadouri:" + item.compressPath);
          });
        }
      }
      this.lazyLoad();
      setTimeout(() => {
        cornerstone.reset(this.itemElementList[0]);
        cornerstone.reset(this.itemElementList[1]);
      }, 100);
    },
    clickDemopua(index) {
      if (this.showindex) {
        this.baseAction[this.showindex].clicked = false;
      }
      console.log("new", this.copyList);
      console.log("nwwwwww", this.domeindex);
      // this.aaa = this.user.seriesList[indexs].list;
      this.aaa = this.copyList[index].list;
      console.error("aaaa", this.aaa);
      var imageIder = [];
      this.aaa.map((item) => {
        imageIder.push("wadouri:" + item.compressPath);
      });
      // console.log(imageIder)
      // console.log(imageIder)
      var imageIds = imageIder;
      // 设置滚动工具
      const StackScrollMouseWheelTool =
        cornerstoneTools.StackScrollMouseWheelTool;
      //初始化
      // cornerstoneTools.init();
      // const element = document.getElementById("aaa");
      const element = this.itemElementList[index];
      // cornerstone.enable(element);
      // 设置 stack
      const stack = {
        currentImageIdIndex: 0,
        imageIds: imageIds,
      };
      // setTimeout(() => {
      cornerstone.loadAndCacheImage(imageIds[0]).then((image) => {
        //开始
        // console.error('image',image)
        // console.log("elemenetttt", element);
        // cornerstone.displayImage(element, image);
        cornerstoneTools.addStackStateManager(element, ["stack"]);
        cornerstoneTools.addToolState(element, "stack", {
          currentImageIdIndex: 0,
          imageIds: imageIds,
        });
        this.tools = cornerstoneTools.getElementToolStateManager(element);
        // 结束
        // console.error(this.tools);
        // 监听滚动
        element.addEventListener(cornerstone.EVENTS.NEW_IMAGE, this.domess);
      });
      // }, 10);
      // load images and set the stack
      cornerstoneTools.addTool(StackScrollMouseWheelTool);
      cornerstoneTools.setToolActive("StackScrollMouseWheel", {});
    },
    clickMagnifier() {
      console.log(123);
      cornerstoneTools.init();

      // Enable any elements, and display images
      // ...

      // Add our tool, and set it's mode
      const MagnifyTool = cornerstoneTools.MagnifyTool;

      cornerstoneTools.addTool(MagnifyTool);
      cornerstoneTools.setToolActive("Magnify", { mouseButtonMask: 1 });
    },
    clickpreservation() {
      console.log("arr1", this.copyarr1);
      this.copyarr1.forEach((item) => {
        console.log("item", item.formatId);
        if (item.formatId != undefined) {
          this.formData.filmsId.push(item.formatId);
        }
      });
      console.log("this.formData", this.formData);
      this.http
        .post(
          this.GLOBAL.BASE_URL + "v1/study/printdata?token=" +
          sessionStorage.getItem("token"),
          this.formData
        )
        .then((response) => {
          console.log(response);
          if (response.data.code == 200) {
            this.formData.filmsId = [];
            this.$message({
              message: "保存成功",
              type: "success",
            });
            return;
          }
          this.$message({
            message: response.data.msg,
            type: "error",
          });
          // this.$refs["upload"].$refs["upload-inner"].handleChangeedit()
        })
        .catch((err) => {
          console.error(err);
        });
    },
    deleteCardItem(index) {
      console.log("index", index);
      const elementcard = document.querySelectorAll(".cardDcm_layout");
      for (let i = 0; i < elementcard.length; i++) {
        if (i >= this.copyarr1.length) {
          break;
        }
        cornerstone.disable(elementcard[index]);
      }
      //     console.log("this.copyList", this.copyarr1);
      // this.copyarr1.splice(this.focusElementIndexCard, 1);
      // console.log('this.copyarr1',this.copyarr1);
      this.copyarr1[this.focusElementIndexCard] = "";
      this.showCardcard = false;
    },
    Card22(index) {
      switch (index) {
        case 1:
          ((this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 1)),
            this.changeLayoutCard(1);
          break;
        case 2:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 1),
            this.changeLayoutCard(2);
          break;
        case 3:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 1),
            this.changeLayoutCard(3);
          break;
        case 4:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 1),
            this.changeLayoutCard(4);
          break;
        case 5:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 1),
            this.changeLayoutCard(5);
          break;
        case 6:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 1),
            this.changeLayoutCard(6);
          break;
        case 7:
          (this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 2),
            this.changeLayoutCard(7);
          break;
        case 8:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 2),
            this.changeLayoutCard(8);
          break;
        case 9:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 2),
            this.changeLayoutCard(9);
          break;
        case 10:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 2),
            this.changeLayoutCard(10);
          break;
        case 11:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 2),
            this.changeLayoutCard(11);
          break;
        case 12:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 2),
            this.changeLayoutCard(12);
          break;
        case 13:
          (this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 3),
            this.changeLayoutCard(13);
          break;
        case 14:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 3),
            this.changeLayoutCard(14);
          break;
        case 15:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 3),
            this.changeLayoutCard(15);
          break;
        case 16:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 3),
            this.changeLayoutCard(16);
          break;
        case 17:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 3),
            this.changeLayoutCard(17);
          break;
        case 18:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 3),
            this.changeLayoutCard(18);
          break;
        case 19:
          (this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 4),
            this.changeLayoutCard(19);
          break;
        case 20:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 4),
            this.changeLayoutCard(20);
          break;
        case 21:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 4),
            this.changeLayoutCard(21);
          break;
        case 22:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 4),
            this.changeLayoutCard(22);
          break;
        case 23:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 4),
            this.changeLayoutCard(23);
          break;
        case 24:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 4),
            this.changeLayoutCard(24);
          break;
        case 25:
          (this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 5),
            this.changeLayoutCard(25);
          break;
        case 26:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 5),
            this.changeLayoutCard(26);
          break;
        case 27:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 5),
            this.changeLayoutCard(27);
          break;
        case 28:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 5),
            this.changeLayoutCard(28);
          break;
        case 29:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 5),
            this.changeLayoutCard(29);
          break;
        case 30:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 5),
            this.changeLayoutCard(30);
          break;
        case 31:
          (this.innerVisible = false),
            (this.formData.options.width = 1),
            (this.formData.options.height = 6),
            this.changeLayoutCard(31);
          break;
        case 32:
          (this.innerVisible = false),
            (this.formData.options.width = 2),
            (this.formData.options.height = 6),
            this.changeLayoutCard(32);
          break;
        case 33:
          (this.innerVisible = false),
            (this.formData.options.width = 3),
            (this.formData.options.height = 6),
            this.changeLayoutCard(33);
          break;
        case 34:
          (this.innerVisible = false),
            (this.formData.options.width = 4),
            (this.formData.options.height = 6),
            this.changeLayoutCard(34);
          break;
        case 35:
          (this.innerVisible = false),
            (this.formData.options.width = 5),
            (this.formData.options.height = 6),
            this.changeLayoutCard(35);
          break;
        case 36:
          (this.innerVisible = false),
            (this.formData.options.width = 6),
            (this.formData.options.height = 6),
            this.changeLayoutCard(36);
          break;
      }
    },
    changeLayoutCard(index) {
      switch (index) {
        case 1:
          this.layoutClassCard = "auto_layout1";
          break;
        case 2:
          this.layoutClassCard = "autocard_layout2";
          break;
        case 3:
          this.layoutClassCard = "autocard_layout3";
          break;
        case 4:
          this.layoutClassCard = "autocard_layout4";
          break;
        case 5:
          this.layoutClassCard = "autocard_layout5";
          break;
        case 6:
          this.layoutClassCard = "autocard_layout6";
          break;
        case 7:
          this.layoutClassCard = "autocard_layout7";
          break;
        case 8:
          this.layoutClassCard = "autocard_layout8";
          break;
        case 9:
          this.layoutClassCard = "autocard_layout9";
          break;
        case 10:
          this.layoutClassCard = "autocard_layout10";
          break;
        case 11:
          this.layoutClassCard = "autocard_layout11";
          break;
        case 12:
          this.layoutClassCard = "autocard_layout12";
          break;
        case 13:
          this.layoutClassCard = "autocard_layout13";
          break;
        case 14:
          this.layoutClassCard = "autocard_layout14";
          break;
        case 15:
          this.layoutClassCard = "autocard_layout15";
          break;
        case 16:
          this.layoutClassCard = "autocard_layout16";
          break;
        case 17:
          this.layoutClassCard = "autocard_layout17";
          break;
        case 18:
          this.layoutClassCard = "autocard_layout18";
          break;
        case 19:
          this.layoutClassCard = "autocard_layout19";
          break;
        case 20:
          this.layoutClassCard = "autocard_layout20";
          break;
        case 21:
          this.layoutClassCard = "autocard_layout21";
          break;
        case 22:
          this.layoutClassCard = "autocard_layout22";
          break;
        case 23:
          this.layoutClassCard = "autocard_layout23";
          break;
        case 24:
          this.layoutClassCard = "autocard_layout24";
          break;
        case 25:
          this.layoutClassCard = "autocard_layout25";
          break;
        case 26:
          this.layoutClassCard = "autocard_layout26";
          break;
        case 27:
          this.layoutClassCard = "autocard_layout27";
          break;
        case 28:
          this.layoutClassCard = "autocard_layout28";
          break;
        case 29:
          this.layoutClassCard = "autocard_layout29";
          break;
        case 30:
          this.layoutClassCard = "autocard_layout30";
          break;
        case 31:
          this.layoutClassCard = "autocard_layout31";
          break;
        case 32:
          this.layoutClassCard = "autocard_layout32";
          break;
        case 33:
          this.layoutClassCard = "autocard_layout33";
          break;
        case 34:
          this.layoutClassCard = "autocard_layout34";
          break;
        case 35:
          this.layoutClassCard = "autocard_layout35";
          break;
        case 36:
          this.layoutClassCard = "autocard_layout36";
          break;
      }
      setTimeout(() => {
        console.log(this.itemElementListcard);
        this.itemElementListcard.forEach((item) => {
          cornerstone.resize(item);
        });
      }, 10);
    },
    changeDcmCard(index) {
      //弹窗的右侧点击事件
      // const copyarr2 = this.copyarr1;
      this.copyarr1[this.focusElementIndexCard] = this.arr1[index];
      console.error("this.copyarr1", this.copyarr1);
      // console.error("this.arr1", this.arr1);
      cornerstoneTools.init();
      // this.domeindexCard
      this.domeindexCard = index;
      console.error("this.domeindexCard", this.focusElementIndexCard);
      const elementCard = this.itemElementListcard[this.focusElementIndexCard];
      cornerstone.enable(elementCard);
      const imageIdCard = "wadouri:" + this.arr1[index].compressPath;
      console.log("domeindexCard", imageIdCard);
      cornerstone.loadAndCacheImage(imageIdCard).then((image) => {
        setTimeout(function () {
          console.log("elementCard", elementCard);
          // cornerstone.resize(elementCard);
          //  cornerstoneTools.clearToolState(element,"StackScrollMouseWheel")
          // cornerstone.updateImage(elementCard)
          // cornerstone.displayImage(elementCard, image);
          cornerstone.displayImage(elementCard, image);
          // 222
        }, 100);
        // this.moveTools();
        // this.clickDemo();
        setTimeout(() => {
          this.resverTools();
          // this.imageNumber = 1;
        }, 100);
      });
    },
    clickCardLayout(index) {
      this.showCardcard = false;
      console.log("111", 111);
      this.focusElementIndexCard = index;
    },
    ClickImageUrlItem() {
      if (this.successLoding == false) {
        if (this.arr1.length == 0) {
          this.$message({
            type: "error",
            message: "请先标记",
          });
          return;
        }
        this.CardFormVisible = true;
        this.itemElementListcard = [];
        setTimeout(() => {
          const elementcard = document.querySelectorAll(".cardDcm_layout");
          console.log("elementcard", elementcard);
          for (let i = 0; i < elementcard.length; i++) {
            if (i >= this.copyarr1.length) {
              break;
            }
            this.itemElementListcard.push(elementcard[i]);
            // console.log(imagemm)
            const imageId = "wadouri:" + this.copyarr1[i].compressPath;
            cornerstone.enable(elementcard[i]);
            cornerstone.loadAndCacheImage(imageId).then((image) => {
              console.error("image", image);
              // console.log(imagemm.length)
              // console.log(loadSuccessCount)
              // setTimeout(() => {
              //   this.loadSuccessPercent =
              //     (++loadSuccessCount / imagemm.length) * 100;
              // }, 10);
              if (i > 8) {
                return false;
              }
              cornerstone.displayImage(elementcard[i], image);
              this.moveTools();
              // this.form.w = this.lists[0].windowWidth;
              // this.form.l = this.lists[0].windowCenter;
              // this.changeWindow(this.form);
            });
          }
        }, 100);
      } else {
        this.responseList.forEach((item) => {
          console.log(item);
          item.username = this.dataList.username;
          item.studyAge = this.dataList.studyAge;
          item.gender = this.dataList.gender;
          item.times = this.time(item.seriesDateTime);
          this.arr1.push(item);
          this.copyarr1.push(item);
        });
        this.CardFormVisible = true;
        // console.error('this.cardList',response.data.data.options.width);
        this.itemElementListcard = [];
        setTimeout(() => {
          const elementcard = document.querySelectorAll(".cardDcm_layout");
          console.log("elementcard", elementcard);
          for (let i = 0; i < elementcard.length; i++) {
            if (i >= this.copyarr1.length) {
              break;
            }
            this.itemElementListcard.push(elementcard[i]);
            // console.log(imagemm)
            const imageId = "wadouri:" + this.copyarr1[i].compressPath;
            cornerstone.enable(elementcard[i]);
            cornerstone.loadAndCacheImage(imageId).then((image) => {
              console.error("image", image);
              // console.log(imagemm.length)
              // console.log(loadSuccessCount)
              // setTimeout(() => {
              //   this.loadSuccessPercent =
              //     (++loadSuccessCount / imagemm.length) * 100;
              // }, 10);
              if (i > 8) {
                return false;
              }
              cornerstone.displayImage(elementcard[i], image);
              this.moveTools();
              // this.form.w = this.lists[0].windowWidth;
              // this.form.l = this.lists[0].windowCenter;
              // this.changeWindow(this.form);
            });
          }
        }, 100);
      }
    },
    clickCard(imageUrl) {
      // console.log('imageUrl111',imageUrl.list[this.imageNumber - 1].compressPath)
      // var cardList = []
      console.log("111");
      this.showCard = false;
      // this.cardList.push(imageUrl.list[this.imageNumber - 1].compressPath);
      this.CardItemListtab.push(imageUrl.list[this.imageNumber - 1]);
      console.error("imageUrl.list", imageUrl);
      console.error("cardList", this.CardItemListtab);
      this.CardItemListtab.forEach((item) => {
        // 这儿用到indexOf是你在判断如果为-1也就是没有这个值的时候在push
        // 有的话就不push，这个是我写的
        if (this.arr1.indexOf(item) == -1) {
          console.error("item,item", item);
          item.seriesNumber = imageUrl.seriesNumber;
          item.gender = imageUrl.gender;
          item.username = imageUrl.username;
          item.studyAge = imageUrl.studyAge;
          item.seriesDescription = imageUrl.seriesDescription;
          item.windowWidth = imageUrl.windowWidth;
          item.windowCenter = imageUrl.windowCenter;
          item.times = imageUrl.times;
          this.arr1.push(item);
          this.copyarr1.push(item);
          console.log("cardcopyarr1", this.copyarr1);
          this.$message({
            type: "success",
            message: "已标记为关键影像",
          });
          // break;
        }
      });
    },
    rightClick(index, imageUrl, e) {
      this.clickLayout(index, imageUrl);
      (this.showCard = true),
        (this.menuLeft = e.layerX),
        (this.menuTop = e.layerY),
        console.log("xxx", e.layerX);
      console.log("yyy", e.layerY);
      console.log("imageNumber", this.imageNumber);
      console.error("imageUrl", imageUrl[this.imageNumber - 1].compressPath);
    },
    rightClickcard(index, e) {
      this.clickCardLayout(index);
      (this.showCardcard = true),
        (this.menuLeftcard = e.layerX),
        (this.menuTopcard = e.layerY),
        console.log("xxx", e.layerX);
      console.log("yyy", e.layerY);
    },
    clickQuadrangle() {
      this.Quadrangle = !this.Quadrangle;
    },
    loadSeries(images, element, stack) {
      console.error("7777", stack);
      images.forEach((item) => cornerstone.loadAndCacheImage(item));

      return cornerstone.loadAndCacheImage(images[0]).then((img) => {
        console.log(img);
        cornerstone.displayImage(element, img);

        cornerstoneTools.addStackStateManager(element, ["stack"]);
        cornerstoneTools.addToolState(element, "stack", stack);
      });
    },
    addTool() {
      const synchronizer = new cornerstoneTools.Synchronizer(
        "cornerstonenewimage",
        cornerstoneTools.stackImagePositionSynchronizer
      );
      synchronizer.add(this.eee[0]);
      synchronizer.add(this.eee[1]);
      synchronizer.add(this.eee[2]);
      synchronizer.add(this.eee[3]);
      synchronizer.add(this.eee[4]);
      // synchronizer.add(this.eee[5]);
      if (this.wuStack != 0) {
        synchronizer.add(this.eee[5]);
      }
      console.error("bbbbbbbbb", this.liulength);
      if (this.liulength != 0) {
        synchronizer.add(this.eee[6]);
      }
      if (this.qilength != 0) {
        synchronizer.add(this.eee[7]);
      }
      if (this.balength != 0) {
        synchronizer.add(this.eee[8]);
      }
    },

    handleImageRendered(e) {
      e.detail.element.removeEventListener(
        "cornerstoneimagerendered",
        this.handleImageRendered
      );
      console.error("chestStack", e);

      this.numImagesLoaded++;
      if (this.numImagesLoaded === 2) {
        this.addTool();
      }
    },
    // els[0].addEventListener("cornerstoneimagerendered", handleImageRendered);
    // els[1].addEventListener("cornerstoneimagerendered", handleImageRendered);
    onesclick(index) {
      console.error("index", index);
      switch (index) {
        case 0:
          (this.lagyouter = false), this.changeLayout(0);
          break;
        case 1:
          (this.lagyouter = false), this.changeLayout(1);
          break;
        case 2:
          (this.lagyouter = false), this.changeLayout(5);
          break;
        case 3:
          (this.lagyouter = false), this.changeLayout(2);
          break;
        case 4:
          (this.lagyouter = false), this.changeLayout(3);
          break;
        case 5:
          (this.lagyouter = false), this.changeLayout(6);
          break;
        case 6:
          (this.lagyouter = false), this.changeLayout(7);
          break;
        case 7:
          (this.lagyouter = false), this.changeLayout(8);
          break;
        case 8:
          (this.lagyouter = false), this.changeLayout(4);
          break;
        case 9:
          (this.lagyouter = false), this.changeLayout(9);
          break;
        case 13:
          (this.lagyouter = false), this.changeLayout(10);
          break;
        case 14:
          (this.lagyouter = false), this.changeLayout(11);
          break;
        case 15:
          (this.lagyouter = false), this.changeLayout(12);
          break;
        case 41:
          (this.lagyouter = false), this.changeLayout(12);
          break;
        case 42:
          (this.lagyouter = false), this.changeLayout(13);
          break;
        case 43:
          (this.lagyouter = false), this.changeLayout(14);
          break;
        case 16:
          (this.lagyouter = false), this.changeLayout(15);
          break;
      }
    },
    cardHover(id) {
      switch (id) {
        case 1:
          this.card1 = true;
          break;
        case 2:
          this.card1 = true;
          this.card2 = true;
          break;
        case 2:
          this.card1 = true;
          this.card2 = true;
          break;
        case 3:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          break;
        case 4:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          break;
        case 5:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          break;
        case 6:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          break;
        case 7:
          this.card1 = true;
          this.card7 = true;
          break;
        case 8:
          this.card1 = true;
          this.card2 = true;
          this.card7 = true;
          this.card8 = true;
          break;
        case 9:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          break;
        case 10:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          break;
        case 11:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          break;
        case 12:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card12 = true;
          break;
        case 13:
          this.card1 = true;
          this.card7 = true;
          this.card13 = true;
          break;
        case 14:
          this.card1 = true;
          this.card2 = true;
          this.card7 = true;
          this.card8 = true;
          this.card13 = true;
          this.card14 = true;
          break;
        case 15:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          break;
        case 16:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          break;
        case 17:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          break;
        case 18:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card12 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card18 = true;
          break;
        case 19:
          this.card1 = true;
          this.card7 = true;
          this.card13 = true;
          this.card19 = true;
          break;
        case 20:
          this.card1 = true;
          this.card2 = true;
          this.card7 = true;
          this.card8 = true;
          this.card13 = true;
          this.card14 = true;
          this.card19 = true;
          this.card20 = true;
          break;
        case 21:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          break;
        case 22:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          break;
        case 23:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          break;
        case 24:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card12 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card18 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          this.card24 = true;
          break;
        case 25:
          this.card1 = true;
          this.card7 = true;
          this.card13 = true;
          this.card19 = true;
          this.card25 = true;
          break;
        case 26:
          this.card1 = true;
          this.card2 = true;
          this.card7 = true;
          this.card8 = true;
          this.card13 = true;
          this.card14 = true;
          this.card19 = true;
          this.card20 = true;
          this.card25 = true;
          this.card26 = true;
          break;
        case 27:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          break;
        case 28:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          break;
        case 29:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          this.card29 = true;
          break;
        case 30:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card12 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card18 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          this.card24 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          this.card29 = true;
          this.card30 = true;
          break;
        case 31:
          this.card1 = true;
          this.card7 = true;
          this.card13 = true;
          this.card19 = true;
          this.card25 = true;
          this.card31 = true;
          break;
        case 32:
          this.card1 = true;
          this.card2 = true;
          this.card7 = true;
          this.card8 = true;
          this.card13 = true;
          this.card14 = true;
          this.card19 = true;
          this.card20 = true;
          this.card25 = true;
          this.card26 = true;
          this.card31 = true;
          this.card32 = true;
          break;
        case 33:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card31 = true;
          this.card32 = true;
          this.card33 = true;
          break;
        case 34:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          this.card31 = true;
          this.card32 = true;
          this.card33 = true;
          this.card34 = true;
          break;
        case 35:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          this.card29 = true;
          this.card31 = true;
          this.card32 = true;
          this.card33 = true;
          this.card34 = true;
          this.card35 = true;
          break;
        case 36:
          this.card1 = true;
          this.card2 = true;
          this.card3 = true;
          this.card4 = true;
          this.card5 = true;
          this.card6 = true;
          this.card7 = true;
          this.card8 = true;
          this.card9 = true;
          this.card10 = true;
          this.card11 = true;
          this.card12 = true;
          this.card13 = true;
          this.card14 = true;
          this.card15 = true;
          this.card16 = true;
          this.card17 = true;
          this.card18 = true;
          this.card19 = true;
          this.card20 = true;
          this.card21 = true;
          this.card22 = true;
          this.card23 = true;
          this.card24 = true;
          this.card25 = true;
          this.card26 = true;
          this.card27 = true;
          this.card28 = true;
          this.card29 = true;
          this.card30 = true;
          this.card31 = true;
          this.card32 = true;
          this.card33 = true;
          this.card34 = true;
          this.card35 = true;
          this.card36 = true;
          break;
      }
    },
    cardOver(id) {
      switch (id) {
        case 1:
          this.card1 = false;
          break;
        case 2:
          this.card1 = false;
          this.card2 = false;
          break;
        case 2:
          this.card1 = false;
          this.card2 = false;
          break;
        case 3:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          break;
        case 4:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          break;
        case 5:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          break;
        case 6:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          break;
        case 7:
          this.card1 = false;
          this.card7 = false;
          break;
        case 8:
          this.card1 = false;
          this.card2 = false;
          this.card7 = false;
          this.card8 = false;
          break;
        case 9:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          break;
        case 10:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          break;
        case 11:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          break;
        case 12:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card12 = false;
          break;
        case 13:
          this.card1 = false;
          this.card7 = false;
          this.card13 = false;
          break;
        case 14:
          this.card1 = false;
          this.card2 = false;
          this.card7 = false;
          this.card8 = false;
          this.card13 = false;
          this.card14 = false;
          break;
        case 15:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          break;
        case 16:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          break;
        case 17:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          break;
        case 18:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card12 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card18 = false;
          break;
        case 19:
          this.card1 = false;
          this.card7 = false;
          this.card13 = false;
          this.card19 = false;
          break;
        case 20:
          this.card1 = false;
          this.card2 = false;
          this.card7 = false;
          this.card8 = false;
          this.card13 = false;
          this.card14 = false;
          this.card19 = false;
          this.card20 = false;
          break;
        case 21:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          break;
        case 22:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          break;
        case 23:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          break;
        case 24:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card12 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card18 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          this.card24 = false;
          break;
        case 25:
          this.card1 = false;
          this.card7 = false;
          this.card13 = false;
          this.card19 = false;
          this.card25 = false;
          break;
        case 26:
          this.card1 = false;
          this.card2 = false;
          this.card7 = false;
          this.card8 = false;
          this.card13 = false;
          this.card14 = false;
          this.card19 = false;
          this.card20 = false;
          this.card25 = false;
          this.card26 = false;
          break;
        case 27:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          break;
        case 28:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          break;
        case 29:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          this.card29 = false;
          break;
        case 30:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card12 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card18 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          this.card24 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          this.card29 = false;
          this.card30 = false;
          break;
        case 31:
          this.card1 = false;
          this.card7 = false;
          this.card13 = false;
          this.card19 = false;
          this.card25 = false;
          this.card31 = false;
          break;
        case 32:
          this.card1 = false;
          this.card2 = false;
          this.card7 = false;
          this.card8 = false;
          this.card13 = false;
          this.card14 = false;
          this.card19 = false;
          this.card20 = false;
          this.card25 = false;
          this.card26 = false;
          this.card31 = false;
          this.card32 = false;
          break;
        case 33:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card31 = false;
          this.card32 = false;
          this.card33 = false;
          break;
        case 34:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          this.card31 = false;
          this.card32 = false;
          this.card33 = false;
          this.card34 = false;
          break;
        case 35:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          this.card29 = false;
          this.card31 = false;
          this.card32 = false;
          this.card33 = false;
          this.card34 = false;
          this.card35 = false;
          break;
        case 36:
          this.card1 = false;
          this.card2 = false;
          this.card3 = false;
          this.card4 = false;
          this.card5 = false;
          this.card6 = false;
          this.card7 = false;
          this.card8 = false;
          this.card9 = false;
          this.card10 = false;
          this.card11 = false;
          this.card12 = false;
          this.card13 = false;
          this.card14 = false;
          this.card15 = false;
          this.card16 = false;
          this.card17 = false;
          this.card18 = false;
          this.card19 = false;
          this.card20 = false;
          this.card21 = false;
          this.card22 = false;
          this.card23 = false;
          this.card24 = false;
          this.card25 = false;
          this.card26 = false;
          this.card27 = false;
          this.card28 = false;
          this.card29 = false;
          this.card30 = false;
          this.card31 = false;
          this.card32 = false;
          this.card33 = false;
          this.card34 = false;
          this.card35 = false;
          this.card36 = false;
          break;
      }
    },

    practicingone(id) {
      switch (id) {
        case 1:
          this.onelayou = true;
          break;
        case 2:
          this.onelayou = true;
          this.twolayou = true;
          break;
        case 3:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          break;
        case 4:
          this.onelayou = true;
          this.silayou = true;
          break;
        case 5:
          this.onelayou = true;
          this.twolayou = true;
          this.silayou = true;
          this.wulayou = true;
          break;
        case 6:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.silayou = true;
          this.wulayou = true;
          this.liulayou = true;
          break;
        case 7:
          this.onelayou = true;
          this.silayou = true;
          this.qilayou = true;
          break;
        case 8:
          this.onelayou = true;
          this.twolayou = true;
          this.silayou = true;
          this.wulayou = true;
          this.qilayou = true;
          this.balayou = true;
          break;
        case 9:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.silayou = true;
          this.wulayou = true;
          this.liulayou = true;
          this.qilayou = true;
          this.balayou = true;
          this.jiulayou = true;
          break;
        case 10:
          this.onelayou = true;
          this.silayou = true;
          this.qilayou = true;
          this.shilayou = true;
          break;
        case 14:
          this.onelayou = true;
          this.silayou = true;
          this.qilayou = true;
          this.shilayou = true;
          this.twolayou = true;
          this.wulayou = true;
          this.balayou = true;
          this.shisilayou = true;
          break;
        case 15:
          this.onelayou = true;
          this.silayou = true;
          this.qilayou = true;
          this.shilayou = true;
          this.twolayou = true;
          this.wulayou = true;
          this.balayou = true;
          this.shisilayou = true;
          this.sanlayou = true;
          this.liulayou = true;
          this.jiulayou = true;
          this.shiwulayou = true;
          // this.layou = true;
          break;
        case 41:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.siyilayou = true;
          break;
        case 42:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.siyilayou = true;
          this.wulayou = true;
          this.liulayou = true;
          this.silayou = true;
          this.sierlayou = true;
          break;
        case 43:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.siyilayou = true;
          this.wulayou = true;
          this.liulayou = true;
          this.silayou = true;
          this.qilayou = true;
          this.balayou = true;
          this.jiulayou = true;
          this.sisanlayou = true;
          this.sierlayou = true;
          break;
        case 16:
          this.onelayou = true;
          this.twolayou = true;
          this.sanlayou = true;
          this.siyilayou = true;
          this.wulayou = true;
          this.liulayou = true;
          this.silayou = true;
          this.qilayou = true;
          this.balayou = true;
          this.jiulayou = true;
          this.sisanlayou = true;
          this.sierlayou = true;
          this.shiliulayou = true;
          this.shiwulayou = true;
          this.shisilayou = true;
          this.shilayou = true;
          break;
      }
    },
    Leavepracticingone(id) {
      switch (id) {
        case 1:
          this.onelayou = false;
          break;
        case 2:
          this.onelayou = false;
          this.twolayou = false;
          break;
        case 3:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          break;
        case 4:
          this.onelayou = false;
          this.silayou = false;
          break;
        case 5:
          this.onelayou = false;
          this.twolayou = false;
          this.silayou = false;
          this.wulayou = false;
          break;
        case 6:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.silayou = false;
          this.wulayou = false;
          this.liulayou = false;
          break;
        case 7:
          this.onelayou = false;
          this.silayou = false;
          this.qilayou = false;
          break;
        case 8:
          this.onelayou = false;
          this.twolayou = false;
          this.silayou = false;
          this.wulayou = false;
          this.qilayou = false;
          this.balayou = false;
          break;
        case 9:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.silayou = false;
          this.wulayou = false;
          this.liulayou = false;
          this.qilayou = false;
          this.balayou = false;
          this.jiulayou = false;
          break;
        case 10:
          this.onelayou = false;
          this.silayou = false;
          this.qilayou = false;
          this.shilayou = false;
          break;
        case 14:
          this.onelayou = false;
          this.silayou = false;
          this.qilayou = false;
          this.shilayou = false;
          this.twolayou = false;
          this.wulayou = false;
          this.balayou = false;
          this.shisilayou = false;
          break;
        case 15:
          this.onelayou = false;
          this.silayou = false;
          this.qilayou = false;
          this.shilayou = false;
          this.twolayou = false;
          this.wulayou = false;
          this.balayou = false;
          this.shisilayou = false;
          this.sanlayou = false;
          this.liulayou = false;
          this.jiulayou = false;
          this.shiwulayou = false;
          // this.layou = true;
          break;
        case 41:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.siyilayou = false;
          break;
        case 42:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.siyilayou = false;
          this.wulayou = false;
          this.liulayou = false;
          this.silayou = false;
          this.sierlayou = false;
          break;
        case 43:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.siyilayou = false;
          this.wulayou = false;
          this.liulayou = false;
          this.silayou = false;
          this.qilayou = false;
          this.balayou = false;
          this.jiulayou = false;
          this.sisanlayou = false;
          this.sierlayou = false;
          break;
        case 16:
          this.onelayou = false;
          this.twolayou = false;
          this.sanlayou = false;
          this.siyilayou = false;
          this.wulayou = false;
          this.liulayou = false;
          this.silayou = false;
          this.qilayou = false;
          this.balayou = false;
          this.jiulayou = false;
          this.sisanlayou = false;
          this.sierlayou = false;
          this.shiliulayou = false;
          this.shiwulayou = false;
          this.shisilayou = false;
          this.shilayou = false;
          break;
      }
    },
    OverLayou() {
      this.layoutBox = true;
    },
    LeaveLayou() {
      this.layoutBox = false;
    },
    mouseOver(obj) {
      console.log(obj);
      if (obj == 0) {
        this.baseAction[0].url = this.baseAction[0].activeurl;
      }
      if (obj == 1) {
        this.baseAction[1].url = this.baseAction[1].activeurl;
      }
      if (obj == 2) {
        this.baseAction[2].url = this.baseAction[2].activeurl;
      }
      if (obj == 3) {
        this.baseAction[3].url = this.baseAction[3].activeurl;
      }
    },
    mouseLeave(obj) {
      console.log(obj);
      if (obj == 0) {
        this.baseAction[0].url = this.baseAction[0].copyurl;
      }
      if (obj == 1) {
        this.baseAction[1].url = this.baseAction[1].copyurl;
      }
      if (obj == 2) {
        this.baseAction[2].url = this.baseAction[2].copyurl;
      }
      if (obj == 3) {
        this.baseAction[3].url = this.baseAction[3].copyurl;
      }
      if (obj == 4) {
        this.baseAction[4].url = this.baseAction[4].copyurl;
      }
    },
    OverFullscreen() {
      this.screen = true;
    },
    LeaveFullscreen() {
      this.screen = false;
    },
    mousedcmStates(obj) {
      console.log(obj);
      if (obj == 0) {
        this.dcmStates[0].url = this.dcmStates[0].activeurl;
      }
      if (obj == 1) {
        this.dcmStates[1].url = this.dcmStates[1].activeurl;
      }
      if (obj == 2) {
        this.dcmStates[2].url = this.dcmStates[2].activeurl;
      }
      if (obj == 3) {
        this.dcmStates[3].url = this.dcmStates[3].activeurl;
      }
      if (obj == 4) {
        this.dcmStates[4].url = this.dcmStates[4].activeurl;
      }
    },
    LeavedcmStates(obj) {
      console.log(obj);
      if (obj == 0) {
        this.dcmStates[0].url = this.dcmStates[0].copyurl;
      }
      if (obj == 1) {
        this.dcmStates[1].url = this.dcmStates[1].copyurl;
      }
      if (obj == 2) {
        this.dcmStates[2].url = this.dcmStates[2].copyurl;
      }
      if (obj == 3) {
        this.dcmStates[3].url = this.dcmStates[3].copyurl;
      }
      if (obj == 4) {
        this.dcmStates[4].url = this.dcmStates[4].copyurl;
      }
    },
    OvercanvasAction(obj) {
      console.log(obj);
      if (obj == 0) {
        this.canvasAction[0].url = this.canvasAction[0].activeurl;
      }
      if (obj == 1) {
        this.canvasAction[1].url = this.canvasAction[1].activeurl;
      }
      if (obj == 2) {
        this.canvasAction[2].url = this.canvasAction[2].activeurl;
      }
      if (obj == 3) {
        this.canvasAction[3].url = this.canvasAction[3].activeurl;
      }
      if (obj == 4) {
        this.canvasAction[4].url = this.canvasAction[4].activeurl;
      }
      if (obj == 5) {
        this.canvasAction[5].url = this.canvasAction[5].activeurl;
      }
      if (obj == 6) {
        this.canvasAction[6].url = this.canvasAction[6].activeurl;
      }
    },
    LeavecanvasAction(obj) {
      console.log(obj);
      if (obj == 0) {
        this.canvasAction[0].url = this.canvasAction[0].copyurl;
      }
      if (obj == 1) {
        this.canvasAction[1].url = this.canvasAction[1].copyurl;
      }
      if (obj == 2) {
        this.canvasAction[2].url = this.canvasAction[2].copyurl;
      }
      if (obj == 3) {
        this.canvasAction[3].url = this.canvasAction[3].copyurl;
      }
      if (obj == 4) {
        this.canvasAction[4].url = this.canvasAction[4].copyurl;
      }
      if (obj == 5) {
        this.canvasAction[5].url = this.canvasAction[5].copyurl;
      }
      if (obj == 6) {
        this.canvasAction[6].url = this.canvasAction[6].copyurl;
      }
    },
    OverdcmLive() {
      this.dcmLive[0].url = this.dcmLive[0].activeurl;
    },
    OverdcmLivefree() {
      this.dcmLivefree[0].url = this.dcmLivefree[0].activeurl;
    },
    OverdcmFDJ() {
      this.dcmFDJ[0].url = this.dcmFDJ[0].activeurl;
    },
    LeavedcmLive(obj) {
      this.dcmLive[0].url = this.dcmLive[0].copyurl;
    },
    LeavedcmLivefree(obj) {
      this.dcmLivefree[0].url = this.dcmLivefree[0].copyurl;
    },
    LeavedcmFDJ(obj) {
      this.dcmFDJ[0].url = this.dcmFDJ[0].copyurl;
    },
    overlayTool() {
      const el = this.itemElementList[this.focusElementIndex];
      console.error("el", el);
      cornerstoneTools.init();
      console.error("123", 123);
      let ScaleOverlayTool = cornerstoneTools.ScaleOverlayTool;
      cornerstoneTools.addTool(ScaleOverlayTool, {
        configuration: {
          // minorTickLength: 12.5, //小节拍长度
          // majorTickLength: 200, //大节拍长度,并不是总长度,总长度会根据canvas大小调整
          // vscaleBounds:'',
        },
      });
      cornerstoneTools.setToolActive("ScaleOverlay", {
        mouseButtonMask: 1,
      });
    },
    Mprclick() {
      window.location.href =
        "/login#/mpr?userId=" +
        this.ids +
        "&token=" +
        tokens +
        "&index=" +
        this.domeindex +
        "&reloaded=" +
        1;
      // this.$router.push({
      //   path: "/mpr",
      //   query: {
      //     userId: this.ids,
      //     token:sessionStorage.getItem("token"),
      //     index:this.domeindex
      //   },
      // });
    },
    exports() {
      this.changeWindow(this.form);
      this.dialogFormVisible = false;
      this.form.w = "";
      this.form.l = "";
    },
    changeWindow(item) {
      if (item.name == "自定义") {
        console.log(123);
        this.dialogFormVisible = true;
        return;
      }
      this.ww = item.w;
      this.wl = item.l;
      const el = this.itemElementList[this.focusElementIndex];
      let viewport = cornerstone.getViewport(el);
      viewport.voi.windowWidth = this.ww;
      viewport.voi.windowCenter = this.wl;
      // viewport.displayedArea.brhc.x = 670;
      cornerstone.setViewport(el, viewport);
    },
    measureshow() {
      this.measure = !this.measure;
      if (this.measure == true) {
        this.dimensiona = false;
        this.dimensional = false;
        (this.carddimensional = false), (this.functions = false);
        this.hidden = false;
        this.AIshow = false;
      }
    },
    dimensionalshow() {
      this.dimensional = !this.dimensional;
      if (this.dimensional == true) {
        this.dimensiona = false;
        (this.carddimensional = false), (this.measure = false);
        this.functions = false;
        this.hidden = false;
        this.AIshow = false;
      }
    },
    clickAIshow() {
      this.AIshow = !this.AIshow;
      if (this.AIshow == true) {
        this.dimensiona = false;
        (this.carddimensional = false), (this.measure = false);
        this.functions = false;
        this.hidden = false;
      }
    },
    carddimensionalshow() {
      console.log("carddimensional", this.carddimensional);
      this.carddimensional = !this.carddimensional;
      if (this.carddimensional == true) {
        this.dimensiona = false;
        this.AIshow = false;
        // this.carddimensional = false;
        this.measure = false;
        this.functions = false;
        this.hidden = false;
      }
    },
    sequenceHidden() {
      this.hidden = !this.hidden;
      console.log(this.hidden);
      if (this.hidden == true) {
        this.dimensiona = false;
        (this.carddimensional = false), (this.measure = false);
        this.functions = false;
        this.AIshow = false;
        this.dimensional = false;
      }
    },
    functionShow() {
      this.functions = !this.functions;
      if (this.functions == true) {
        this.dimensiona = false;
        (this.carddimensional = false), (this.measure = false);
        this.hidden = false;
        this.AIshow = false;
        this.dimensional = false;
      }
    },
    clickDemo() {
      if (this.showindex) {
        this.baseAction[this.showindex].clicked = false;
      }
      console.log("new", this.copyList);
      console.log("nwwwwww", this.domeindex);
      // this.aaa = this.user.seriesList[indexs].list;
      this.aaa = this.user.seriesList[this.domeindex].list;
      console.error("aaaa", this.aaa);
      var imageIder = [];
      this.aaa.map((item) => {
        imageIder.push("wadouri:" + item.compressPath);
      });
      // console.log(imageIder)
      // console.log(imageIder)
      var imageIds = imageIder;
      // 设置滚动工具
      const StackScrollMouseWheelTool =
        cornerstoneTools.StackScrollMouseWheelTool;
      //初始化
      // cornerstoneTools.init();
      // const element = document.getElementById("aaa");
      console.error("focusElementIndex", this.focusElementIndex);
      const element = this.itemElementList[this.focusElementIndex];
      // cornerstone.enable(element);
      // 设置 stack
      const stack = {
        currentImageIdIndex: 0,
        imageIds: imageIds,
      };
      // setTimeout(() => {
      cornerstone.loadAndCacheImage(imageIds[0]).then((image) => {
        //开始
        // console.error("image", image);
        // console.log("elemenetttt", element);
        cornerstone.displayImage(element, image);
        cornerstoneTools.addStackStateManager(element, ["stack"]);
        cornerstoneTools.addToolState(element, "stack", {
          currentImageIdIndex: 0,
          imageIds: imageIds,
        });
        this.tools = cornerstoneTools.getElementToolStateManager(element);
        // 结束
        console.error(this.tools);
        // 监听滚动
        element.addEventListener(cornerstone.EVENTS.NEW_IMAGE, this.domess);
      });
      // }, 10);
      // load images and set the stack
      cornerstoneTools.addTool(StackScrollMouseWheelTool);
      cornerstoneTools.setToolActive("StackScrollMouseWheel", {});
      this.resverTools();
    },
    domess() {
      let indexss = this.tools.toolState.stack.data[0].currentImageIdIndex;
      console.log("this.tools.toolState.stack.data", this.tools);
      this.imageNumber = indexss + 1;
      this.imagelength = this.tools.toolState.stack.data[0].imageIds.length;
      console.log("length", this.imagelength);
      console.error("imageNumberimageNumberimageNumber", this.imageNumber);
      this.progressNumber = (this.imageNumber / this.imagelength) * 100;
      console.log("this.progressNumber", this.progressNumber);
      //  this.resverTools();
      // 判断到这一个序列的最后一张时 进入下一个序列的第一张图片
      // if (this.aaa.length == indexss + 1 && this.aaa.length != 1) {
      //   this.imageNumber = 1;
      //   // const element = document.getElementById("aaa");
      //   const element = this.itemElementList[this.focusElementIndex];
      //   cornerstone.enable(element);
      //   this.asdasd = Number(this.numbaa) + 1;
      //   console.error(this.asdasd);
      //   //拿lat
      //   this.liss = this.lists[this.asdasd].seriesDescription;
      //   console.log(this.liss);
      //   //拿时间
      //   this.lisstime = this.lists[this.asdasd].times;
      //   console.error(this.lisstime);
      //   console.log(this.lisstime);
      //   let url = this.copyList[this.asdasd].list[0].compressPath;
      //   console.log(url);
      //   const imageId = "wadouri:" + url;
      //   // 拿到序列的第一张url的dicome文件 并渲染
      //   cornerstone.loadAndCacheImage(imageId).then((image) => {
      //     console.log(element);
      //     console.log(image);
      //     setTimeout(() => {
      //       //到这渲染的时候 出问题
      //       // cornerstone.invalidateImageId(element, image);
      //       cornerstone.displayImage(element, image);
      //       this.domeindex = this.domeindex + 1;
      //       this.clickDemo();
      //       // 调用一下初始化
      //       this.resverTools();
      //     }, 10);
      //     element.removeEventListener(
      //       cornerstone.EVENTS.NEW_IMAGE,
      //       this.domess,
      //       false
      //     );
      //     //  wixndow.clearTimeout(timeout,1500)
      //   });
      // }
    },
    time(time = +new Date()) {
      var date = new Date(time + 8 * 3600 * 1000);
      return date.toJSON().substr(0, 19).replace("T", " ").replace(/-/g, "-");
    },
    getStudyInfo() {
      // console.error('11111',sessionStorage.getItem("loadType"))
      if (sessionStorage.getItem("loadType") == "1") {
        depot
          .get({
            url: "/v1/study/film/getStudyInfo",
            params: {
              token: sessionStorage.getItem("token"),
              id: this.ids,
              loadType: 1,
            },
          })
          .then((res) => {
            console.log("reeeeeeeeeee", res);
            this.user = res.data;
            this.lists = this.user.seriesList;
            this.lists.forEach((rerrrrrr) => {
              console.error("rerrrrrr", rerrrrrr);
              this.copyList.push(rerrrrrr);

            });
            //获取钙化点
            this.$http
              .get(
                this.GLOBAL.BASE_URL + "v1/study/film/getLesions" +
                "?studyId="+ this.ids +"&token=" +
                sessionStorage.getItem("token")
              )
              .then((response) => {
                console.log(response.data.data.L.breast[0].lesions[2].mark);
                this.pointMark = response.data.data.L.breast[0].lesions[2].mark

              })
              .catch((err) => {
              });
            // console.error(this.lists)
            this.lengthh = res.data.seriesList.length;
            console.log(this.lengthh);
            this.lists.forEach((element) => {
              console.log(this.time(element.seriesDateTime));
              element.times = this.time(element.seriesDateTime);
            });
            console.log(this.lists);
            setTimeout(() => {
              this.init();
              this.clickDemopua(0);
            }, 10);
          })
          .catch((err) => {
            console.log(err);
          });
      } else {
        depot
          .get({
            url: "/v1/study/film/getStudyInfo",
            params: {
              token: sessionStorage.getItem("token"),
              id: this.ids,
            },
          })
          .then((res) => {
            console.log(res);
            this.user = res.data;
            this.lists = this.user.seriesList;
            this.lists.forEach((rerrrrrr) => {
              console.error("rerrrrrr", rerrrrrr);
              this.copyList.push(rerrrrrr);
            });
            //获取钙化点
            this.$http
              .get(
                this.GLOBAL.BASE_URL + "v1/study/film/getLesions" +
                "?studyId="+ this.ids +"&token=" +
                sessionStorage.getItem("token")
              )
              .then((response) => {
                // console.log(response.data.data.L.breast[0].lesions[2].mark);
                // this.pointMark = response.data.data.L.breast[0].lesions[2].mark


                //LMLO
                console.error('response.data.data.L.breast[1].location',response.data.data.L.breast[1].location)
                if(response.data.data.L.breast[1].location == 'LMLO'){
                  // alert(2);
                  response.data.data.L.breast[1].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('element',element.locat);
                      // this.newarray.push(element.locat);
                      //  this.newarray = [].concat(...element.locat);
                      this.newarray.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      // this.pointMark = element.mark
                      this.pointMark.push(element.mark);
                      this.pointMark = [].concat(...this.pointMark);
                    }
                  });
                }else {
                  // alert(2);
                  response.data.data.L.breast[0].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('element',element.locat);
                      // this.newarray.push(element.locat);
                      //  this.newarray = [].concat(...element.locat);
                      this.newarray.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      // this.pointMark = element.mark
                      this.pointMark.push(element.mark);
                      this.pointMark = [].concat(...this.pointMark);
                    }
                  });
                }

                //LCC
                if(response.data.data.L.breast[1].location == 'LCC'){
                  response.data.data.L.breast[1].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){

                      // this.newarrayLCC.push(element.locat);
                      //  this.newarrayLCC = [].concat(...element.locat);
                      this.newarrayLCC.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      // this.pointMarkLCC = element.mark
                      this.pointMarkLCC.push(element.mark);
                      this.pointMarkLCC = [].concat(...this.pointMarkLCC);
                    }
                  });
                }else {
                  response.data.data.L.breast[0].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){

                      // this.newarrayLCC.push(element.locat);
                      //  this.newarrayLCC = [].concat(...element.locat);
                      this.newarrayLCC.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      // this.pointMarkLCC = element.mark
                      this.pointMarkLCC.push(element.mark);
                      this.pointMarkLCC = [].concat(...this.pointMarkLCC);
                    }
                  });
                }

                //RMLO
                if(response.data.data.R.breast[0].location == 'RMLO'){
                  response.data.data.R.breast[0].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('elementRMLO',[].concat(...element.locat));
                      // this.newarrayRMLO.push(element.locat);
                      // this.newarrayRMLO.push([].concat(...element.locat));
                      // this.newarrayRMLO = [].concat(...element.locat);
                      this.newarrayRMLO.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarrayRMLO',this.newarrayRMLO);
                    }else if(element.type == 'calcs'){
                      // this.pointMarkRMLO = element.mark
                      this.pointMarkRMLO.push(element.mark);
                      this.pointMarkRMLO = [].concat(...this.pointMarkRMLO);
                    }
                  });
                }else {
                  response.data.data.R.breast[1].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('elementRMLO',[].concat(...element.locat));
                      // this.newarrayRMLO.push(element.locat);
                      // this.newarrayRMLO.push([].concat(...element.locat));
                      // this.newarrayRMLO = [].concat(...element.locat);
                      this.newarrayRMLO.push(element.locat.toString().split(",").map((item) => +item));
                      // console.error('this.newarrayRMLO',this.newarrayRMLO);
                    }else if(element.type == 'calcs'){
                      // this.pointMarkRMLO = element.mark
                      this.pointMarkRMLO.push(element.mark);
                      this.pointMarkRMLO = [].concat(...this.pointMarkRMLO);
                    }
                  });
                }

                //RCC
                if(response.data.data.R.breast[0].location == 'RCC'){
                  response.data.data.R.breast[0].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('element',element.locat);

                      this.newarrayRCC.push(element.locat.toString().split(",").map((item) => +item));
                      // this.newarrayRCC.push([100,200,300,400,500,600,700,1800])
                      // this.newarrayRCC = this.newarrayRCC.toString().split(",").map((item) => +item)
                      // this.newarrayRCC = element.locat.toString().split(",").map((item) => +item)

                      // console.error('arrnew',arrnew)
                      //  this.newarrayRCC = [].concat(...this.newarrayRCC);
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      this.pointMarkRCC.push(element.mark);
                      this.pointMarkRCC = [].concat(...this.pointMarkRCC)
                      console.error('this.pointMarkRCC',this.pointMarkRCC);
                    }
                  });
                }else {
                  response.data.data.R.breast[1].lesions.forEach(element => {
                    // console.error('element',element.locat);
                    if(element.type == 'masses'){
                      // console.error('element',element.locat);

                      this.newarrayRCC.push(element.locat.toString().split(",").map((item) => +item));
                      // this.newarrayRCC.push([100,200,300,400,500,600,700,1800])
                      // this.newarrayRCC = this.newarrayRCC.toString().split(",").map((item) => +item)
                      // this.newarrayRCC = element.locat.toString().split(",").map((item) => +item)

                      // console.error('arrnew',arrnew)
                      //  this.newarrayRCC = [].concat(...this.newarrayRCC);
                      // console.error('this.newarray',this.newarray);
                    }else if(element.type == 'calcs'){
                      this.pointMarkRCC.push(element.mark);
                      this.pointMarkRCC = [].concat(...this.pointMarkRCC)
                      console.error('this.pointMarkRCC',this.pointMarkRCC);
                    }
                  });
                }
                //  this.newarrayRCC = [].concat(...response.data.data.R.breast[1].lesions[].locat);

                console.error('this.newarrayRCC',this.newarrayRCC)
              })
              .catch((err) => {
              });
            // this.copyList = this.lists;
            // console.error(this.lists)
            this.lengthh = res.data.seriesList.length;
            console.log(this.lengthh);
            this.lists.forEach((element) => {
              console.log(this.time(element.seriesDateTime));
              element.times = this.time(element.seriesDateTime);
            });
            console.log(this.lists);
            setTimeout(() => {
              this.init();
              this.clickDemopua(0);
            }, 10);
          })
          .catch((err) => {
            console.log(err);
          });
      }
    },
    baseActionDown(index) {
      console.log(index);
      this.showindex = index;
      // console.log()
      this.baseAction.forEach((item) => {
        item.clicked = false;
      });
      this.canvasAction.forEach((item) => {
        item.clicked = false;
      });
      this.baseAction[index].clicked = true;
      this.judgeBaseAction(this.baseAction[index].tag);
    },
    canvasActionDown(index) {
      console.log("index", index);
      // console.log(data.clicked);
      this.baseAction.forEach((item) => {
        item.clicked = false;
      });
      if (
        this.canvasAction[index].tag !== "back" &&
        this.canvasAction[index].tag !== "clear"
      ) {
        this.canvasAction.forEach((item) => {
          item.clicked = false;
        });
        this.canvasAction[index].clicked = true;
      }
      this.judgeCanvasAction(this.canvasAction[index].tag);
    },
    judgeCanvasAction(tag) {
      switch (tag) {
        case "length":
          this.lengthTools();
          break;
        case "rectangle":
          this.rectangleTools();
          break;
        case "angle":
          this.angleTools();
          break;
        case "ellipse":
          this.ellipseTools();
          break;
        case "cross":
          this.crossTools();
          break;
        case "freehandRoi":
          this.freehandRoiTools();
          break;
        case "back":
          this.backTools();
          break;
        case "clear":
          this.clearCanvasTools();
          break;
      }
    },
    judgeBaseAction(tag) {
      switch (tag) {
        case "zoom":
          this.zoomTools();
          break;
        case "move":
          this.moveTools();
          break;
        case "wwwc":
          this.wwwcTools();
          break;
        case "resver":
          this.resverTools();
          break;
      }
    },
    clearCanvasTools() {
      let element = this.itemElementList[this.focusElementIndex];
      for (let i = 0; i < this.canvasTools.length; i++) {
        cornerstoneTools.clearToolState(element, this.canvasTools[i]);
      }
      cornerstone.updateImage(element);
    },
    clearCanvasToolsindex(index) {
      let element = this.itemElementList[index];
      for (let i = 0; i < this.canvasTools.length; i++) {
        cornerstoneTools.clearToolState(element, this.canvasTools[i]);
      }
      cornerstone.updateImage(element);
    },
    clearCanvasToolscard() {
      let element = this.itemElementListcard[this.focusElementIndexCard];
      for (let i = 0; i < this.canvasTools.length; i++) {
        cornerstoneTools.clearToolState(element, this.canvasTools[i]);
      }
      cornerstone.updateImage(element);
    },
    freehandRoiTools() {
      const FreehandRoiTool = cornerstoneTools.FreehandRoiTool;
      cornerstoneTools.addTool(FreehandRoiTool);
      cornerstoneTools.setToolActive("FreehandRoi", { mouseButtonMask: 1 });
    },
    crossTools() {
      const BidirectionalTool = cornerstoneTools.BidirectionalTool;
      cornerstoneTools.addTool(BidirectionalTool);
      cornerstoneTools.setToolActive("Bidirectional", { mouseButtonMask: 1 });
    },
    ellipseTools() {
      const EllipticalRoiTool = cornerstoneTools.EllipticalRoiTool;
      cornerstoneTools.addTool(EllipticalRoiTool);
      cornerstoneTools.setToolActive("EllipticalRoi", { mouseButtonMask: 1 });
    },
    angleTools() {
      const AngleTool = cornerstoneTools.AngleTool;
      cornerstoneTools.addTool(AngleTool);
      cornerstoneTools.setToolActive("Angle", { mouseButtonMask: 1 });
    },
    backTools() {
      let element = this.itemElementList[this.focusElementIndex];
      var markings = cornerstoneTools.getToolState(element, "RectangleRoi");
      cornerstoneTools.removeToolState(
        element,
        "RectangleRoi",
        markings.data[0]
      );
      cornerstone.updateImage(element);
    },
    rectangleTools() {
      const RectangleRoiTool = cornerstoneTools.RectangleRoiTool;
      cornerstoneTools.addTool(RectangleRoiTool);
      cornerstoneTools.setToolActive("RectangleRoi", { mouseButtonMask: 1 });
    },
    lengthTools() {
      const LengthTool = cornerstoneTools.LengthTool;
      cornerstoneTools.addTool(LengthTool);
      cornerstoneTools.setToolActive("Length", { mouseButtonMask: 1 });
    },
    resverTools() {
      this.baseAction.forEach((item) => {
        item.clicked = false;
      });
      cornerstone.reset(this.itemElementList[this.focusElementIndex]);
      // cornerstone.reset(this.itemElementList[0]);
      // cornerstone.reset(this.itemElementList[1]);
      // cornerstone.reset(this.itemElementList[2]);
      // cornerstone.reset(this.itemElementList[3]);
    },
    wwwcTools() {
      const WwwcTool = cornerstoneTools.WwwcTool;
      cornerstoneTools.addTool(WwwcTool);
      cornerstoneTools.setToolActive("Wwwc", { mouseButtonMask: 1 });
      const el = this.itemElementList[this.focusElementIndex];
      let viewport = cornerstone.getViewport(el);
      this.form = {
        w: Number(viewport.voi.windowWidth),
        l: Number(viewport.voi.windowCenter),
      };
      this.changeWindow(this.form);
    },
    moveTools() {
      const PanTool = cornerstoneTools.PanTool;
      cornerstoneTools.addTool(PanTool);
      cornerstoneTools.setToolActive("Pan", { mouseButtonMask: 1 });
    },
    zoomTools() {
      const ZoomMouseWheelTool = cornerstoneTools.ZoomMouseWheelTool;
      cornerstoneTools.addTool(ZoomMouseWheelTool, {
        configuration: {
          invert: false,
          preventZoomOutsideImage: false,
          minScale: 0.1,
          maxScale: 20.0,
        },
      });
      cornerstoneTools.setToolActive("ZoomMouseWheel", { mouseButtonMask: 1 });
    },
    clearCanvas(){
      try {
        this.contextonImageRenderedzhongkuai.clearRect(0,0,1000,600);
        this.contextonImageRenderedzhongkuai.beginPath();
      }catch (e) {
        console.error("clearCanvas异常",e);
      }
    },
    changeDcm(index) {
      //右侧点击事件
      console.log(index);
      this.clearCanvas();
      this.colorquan = true;
      this.clickzhongkuai()
      this.colordian = true;
      this.clicktumor()
      const element = this.itemElementList[index];
      this.copyList[this.focusElementIndex] = this.lists[index];
      // console.log("this.copyList", this.copyList);
      console.log("this.lists", this.lists);
      console.log(element);
      // const element = document.getElementById("aaa");
      // console.log(index);
      this.domeindex = index;
      this.liss = this.lists[index].seriesDescription;
      console.log(this.liss);
      this.lisstime = this.lists[index].times;
      console.log(this.lisstime);
      // this.latPos = this.user.seriesList[index].seriesDescription;
      this.times = this.user.seriesList[index].times;
      //  setTimeout(function () {
      //  cornerstone.disable(this.itemElementList[this.focusElementIndex]);
      //  }, 10);
      const imageId =
        "wadouri:" + this.user.seriesList[index].list[0].compressPath;
      console.error("imageId", imageId);
      //  console.error(url);
      cornerstone.enable(element);
      const viewport = cornerstone.getViewport(element);
      // viewport.displayedArea.rowPixelSpacing  = 0.1
      // console.log(this.user.seriesList[index].compressPath);
      cornerstone.loadAndCacheImage(imageId).then((image) => {
        this.moveTools();
        this.clickDemo();
        setTimeout(() => {
          this.resverTools();
          this.imageNumber = 1;
        }, 600);
      });
      // 123
      this.form.w = this.lists[index].windowWidth;
      this.form.l = this.lists[index].windowCenter;
      this.changeWindow(this.form);
      //111111111

      // setInterval(() => {
      this.colorquan = false;
      this.clickzhongkuai();
      this.colorquan = true
      this.colordian = false;
      this.clicktumor();
      this.colordian = true
      // }, 500);
    },
    shishiClick(index) {
      console.error("双击", index);
      // 一格布局
      // this.changeLayout(0);
      // this.changeDcm(index);
    },
    clickLayout(index, imageUrl) {
      (this.showCard = false), console.error("50index", index);
      this.domeindex = this.domeindex;
      this.focusElementIndex = index;
      console.error(this.focusElementIndex);
      this.liss = this.lists[index].seriesDescription;
      console.log(this.liss);
      this.lisstime = this.lists[index].times;
      //简写
      // this.clickDemopua(index)
      // 111
    },
    changeDcmState(index) {
      console.log(index);
      let element = this.itemElementList[this.focusElementIndex];
      const viewport = cornerstone.getViewport(element);
      console.log(viewport);
      switch (index) {
        case 0:
          viewport.rotation += 90;
          break;
        case 1:
          viewport.rotation -= 90;
          break;
        case 2:
          viewport.hflip = !viewport.hflip;
          break;
        case 3:
          viewport.vflip = !viewport.vflip;
          break;
        case 4:
          viewport.invert = !viewport.invert;
          break;
        case 5:
          // viewport.invert = !viewport.invert;
          break;
      }
      cornerstone.setViewport(element, viewport);
    },
    changeLayout(index) {
      console.log("index", index);
      this.layouts.forEach((item) => {
        console.log("itemss", item);
        item.clicked = false;
      });
      let layout = this.layouts[index];
      console.error("layout", this.layouts);
      layout.clicked = true;
      this.loopCount = parseInt(layout.tag);
      this.focusElementIndex = 0;
      switch (layout.tag) {
        case 1:
          this.layoutClass = "auto_layout1";
          break;
        case 2:
          this.layoutClass = "auto_layout2";
          break;
        case 2.1:
          this.layoutClass = "auto_layout2_1";
          break;
        case 4:
          this.layoutClass = "auto_layout4";
          break;
        case 9:
          this.layoutClass = "auto_layout99";
          break;
        case 11:
          this.layoutClass = "auto_layout11";
          break;
        case 66:
          this.layoutClass = "auto_layout66";
          break;
        case 22:
          this.layoutClass = "auto_layout22";
          break;
        case 88:
          this.layoutClass = "auto_layout88";
          break;
        case 14:
          this.layoutClass = "auto_layout14";
          break;
        case 24:
          this.layoutClass = "auto_layout24";
          break;
        case 34:
          this.layoutClass = "auto_layout34";
          break;
        case 44:
          this.layoutClass = "auto_layout44";
          break;
        case 41:
          this.layoutClass = "auto_layout41";
          break;
        case 42:
          this.layoutClass = "auto_layout42";
          break;
        case 43:
          this.layoutClass = "auto_layout43";
          break;
        case 16:
          this.layoutClass = "auto_layout16";
          break;
      }
      setTimeout(() => {
        console.log(this.itemElementList);
        this.itemElementList.forEach((item) => {
          cornerstone.resize(item);
        });
      }, 10);
    },
    lazyLoad() {
      this.itemElementList = [];
      const elements = document.querySelectorAll(".dcm_layout");
      console.log("1111", elements);
      // console.error(elements);
      for (let i = 0; i < elements.length; i++) {
        if (i >= this.copyList.length) {
          break;
        }
        this.itemElementList.push(elements[i]);
        // console.log(imagemm)
        const imageId = "wadouri:" + this.copyList[i].list[0].compressPath;
        cornerstone.enable(elements[i]);
        cornerstone.loadAndCacheImage(imageId).then((image) => {
          // console.error("image", image);
          // console.log(imagemm.length)
          // console.log(loadSuccessCount)
          // setTimeout(() => {
          //   this.loadSuccessPercent =
          //     (++loadSuccessCount / imagemm.length) * 100;
          // }, 10);
          if (i > 8) {
            return false;
          }
          cornerstone.displayImage(elements[i], image);
          // this.moveTools();
          // this.form.w = this.lists[0].windowWidth;
          // this.form.l = this.lists[0].windowCenter;
          // this.changeWindow(this.form);
        });
      }
      setTimeout(() => {
        // 刻度尺
        // this.overlayTool();
        console.error(
          "this.itemElementListthis.itemElementList",
          this.itemElementList
        );
        if (window.screen.availHeight < window.screen.availWidth) {
          this.clicktumor();
          this.clickzhongkuai();
        }
        this.moveTools();
      }, 10);
    },
    swapArrData(index1, index2, arr) {
      //index1,index2代表需要交换的数组索引
      const temp = arr.splice(index2, 1, arr[index1]);
      arr[index1] = temp[0];
      return arr;
    },
    // 预加载
    precess() {
      this.itemElementList = [];
      const elements = document.querySelectorAll(".dcm_layout");
      this.eee = elements;
      // console.error(elements);
      let loadSuccessCount = 0;

      var arrs = [];
      for (let i = 0; i < this.copyList.length; i++) {
        if (
          this.copyList[i].seriesDescription ==
          "R MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(0,i,this.user.seriesList);
          this.swapArrData(0, i, this.copyList);
        }
        if (
          this.copyList[i].seriesDescription ==
          "L MLO Tomosynthesis ReconstructionCT Image"
        ) {
          // this.swapArrData(1,i,this.user.seriesList);
          this.swapArrData(1, i, this.copyList);
        }
        if (this.copyList[i].seriesDescription == "R CC") {
          // this.swapArrData(2,i,this.user.seriesList);
          this.swapArrData(2, i, this.copyList);
        }
        if (this.copyList[i].seriesDescription == "L CC") {
          // this.swapArrData(3,i,this.user.seriesList);
          this.swapArrData(3, i, this.copyList);
        }
        // console.error("item", this.user.seriesList[i].list.length);
        // console.log(this.user.seriesList[i]);
        //  setInterval(() => {

        //  }, 10);
        console.error("this.copyList", this.copyList);
      }
      for (let i = 0; i < this.copyList.length; i++) {
        this.copyList[i].list.map((item) => {
          arrs.push("wadouri:" + item.compressPath);
        });
      }

      var imagemm = arrs;
      this.iamgelength = imagemm.length;
      for (let l = 0; l < imagemm.length; l++) {
        cornerstone.loadAndCacheImage(imagemm[l]).then((image) => {
          // console.error('im',image)
          // image.width = 5000
          // setTimeout(() => {
          this.loadSuccessPercent = (++loadSuccessCount / imagemm.length) * 100;
          this.loadSuccessPercent = parseInt(this.loadSuccessPercent);
          // }, 1000);
        });
      }
      cornerstoneWADOImageLoader.external.cornerstone = cornerstone;
      cornerstoneWADOImageLoader.external.dicomParser = dicomParser;
      cornerstoneTools.external.cornerstoneMath = cornerstoneMath;
      cornerstoneTools.external.cornerstone = cornerstone;
      cornerstoneTools.external.Hammer = Hammer;
      let onearray = [];
      if (this.copyList[0] != undefined) {
        this.copyList[0].list.map((item) => {
          onearray.push("wadouri:" + item.compressPath);
        });
      }
      let yiarray = [];
      if (this.copyList[1] != undefined) {
        this.copyList[1].list.map((item) => {
          yiarray.push("wadouri:" + item.compressPath);
        });
      }
      let twoarray = [];
      if (this.copyList[2] != undefined) {
        this.copyList[2].list.map((item) => {
          twoarray.push("wadouri:" + item.compressPath);
        });
      }
      let sanarray = [];
      if (this.copyList[3] != undefined) {
        this.copyList[3].list.map((item) => {
          sanarray.push("wadouri:" + item.compressPath);
        });
      }
      let siarray = [];
      console.error(this.copyList[4]);
      if (this.copyList[4] != undefined) {
        this.copyList[4].list.map((item) => {
          siarray.push("wadouri:" + item.compressPath);
        });
      }
      let wuarray = [];
      console.error(this.copyList[5]);
      if (this.copyList[5] != undefined) {
        this.copyList[5].list.map((item) => {
          wuarray.push("wadouri:" + item.compressPath);
        });
      }
      console.error(this.copyList[6]);
      let liuarray = [];
      if (this.copyList[6] != undefined) {
        this.copyList[6].list.map((item) => {
          liuarray.push("wadouri:" + item.compressPath);
        });
      }
      let qiarray = [];
      console.error(this.copyList[7]);
      if (this.copyList[7] != undefined) {
        this.copyList[7].list.map((item) => {
          qiarray.push("wadouri:" + item.compressPath);
        });
      }
      let baarray = [];
      console.error(this.copyList[8]);
      if (this.copyList[8] != undefined) {
        this.copyList[8].list.map((item) => {
          baarray.push("wadouri:" + item.compressPath);
        });
      }
      let jiuarray = [];
      console.error(this.copyList[9]);
      if (this.copyList[9] != undefined) {
        this.copyList[9].list.map((item) => {
          baarray.push("wadouri:" + item.compressPath);
        });
      }

      const chestStack = {
        currentImageIdIndex: 0,
        imageIds: twoarray,
      };

      const topgramStack = {
        currentImageIdIndex: 0,
        imageIds: onearray,
      };
      const sanStack = {
        currentImageIdIndex: 0,
        imageIds: sanarray,
      };
      const siStack = {
        currentImageIdIndex: 0,
        imageIds: siarray,
      };
      const wuStack = {
        currentImageIdIndex: 0,
        imageIds: wuarray,
      };
      const liuStack = {
        currentImageIdIndex: 0,
        imageIds: liuarray,
      };
      const qiStack = {
        currentImageIdIndex: 0,
        imageIds: qiarray,
      };
      const baStack = {
        currentImageIdIndex: 0,
        imageIds: baarray,
      };
      const jiuStack = {
        currentImageIdIndex: 0,
        imageIds: jiuarray,
      };
      const yiStack = {
        currentImageIdIndex: 0,
        imageIds: yiarray,
      };
      this.toolName = "Crosshairs";
      topgramStack.imageIds = onearray;
      sanStack.imageIds = sanarray;
      siStack.imageIds = siarray;
      wuStack.imageIds = wuarray;
      liuStack.imageIds = liuarray;
      this.liulength = liuStack.imageIds.length;
      this.liulength = wuStack.imageIds.length;
      this.qilength = qiStack.imageIds.length;
      this.balength = baStack.imageIds.length;
      qiStack.imageIds = qiarray;
      baStack.imageIds = baarray;
      jiuStack.imageIds = jiuarray;
      yiStack.imageIds = yiarray;
      setTimeout(() => {
        if (topgramStack.imageIds.length != 0) {
          this.loadSeries(onearray, this.eee[0], topgramStack);
        }
        if (yiStack.imageIds.length != 0) {
          this.loadSeries(yiarray, this.eee[1], yiStack);
        }
        if (chestStack.imageIds.length != 0) {
          this.loadSeries(twoarray, this.eee[2], chestStack);
        }
        if (sanStack.imageIds.length != 0) {
          this.loadSeries(sanarray, this.eee[3], sanStack);
        }
        if (siStack.imageIds.length != 0) {
          this.loadSeries(siarray, this.eee[4], siStack);
        }
        if (wuStack.imageIds.length != 0) {
          this.loadSeries(wuarray, this.eee[5], wuStack);
        }
        if (liuStack.imageIds.length != 0) {
          this.loadSeries(liuarray, this.eee[6], liuStack);
        }
        if (qiStack.imageIds.length != 0) {
          this.loadSeries(qiarray, this.eee[7], qiStack);
        }
        if (baStack.imageIds.length != 0) {
          this.loadSeries(baarray, this.eee[8], baStack);
        }
        if (jiuStack.imageIds.length != 0) {
          this.loadSeries(jiuarray, this.eee[9], jiuStack);
        }
        // if (baStack.imageIds.length != 0) {
        // this.loadSeries(baarray, this.eee[8], baStack);
        // }
        cornerstoneTools.addTool(cornerstoneTools.StackScrollTool);
        cornerstoneTools.addTool(cornerstoneTools.StackScrollMouseWheelTool);
        cornerstoneTools.setToolActive("StackScrollMouseWheel", {});
        this.eee[0].addEventListener(
          "cornerstoneimagerendered",
          this.handleImageRendered
        );
        // this.eee[2].addEventListener("cornerstoneimagerendered", this.handleImageRendered);
        // this.eee[5].addEventListener("cornerstoneimagerendered", this.handleImageRendered);
        this.eee[this.copyList.length - 1].addEventListener(
          "cornerstoneimagerendered",
          this.handleImageRendered
        );
        // this.eee[0].addEventListener(cornerstone.EVENTS.NEW_IMAGE,function(){
        //   this.loadSeries(onearray, this.eee[0], topgramStack)
        // })
        this.ImgNUmber = [];
        console.error("this.eee", this.eee);
        this.eee[3].addEventListener(cornerstone.EVENTS.NEW_IMAGE, () => {
          this.ImgNUmber.length = 0;
          this.ImgNUmber.push(topgramStack.currentImageIdIndex);
          console.error(
            "zzzyiStack.currentImageIdIndex",
            yiStack.currentImageIdIndex
          );
          this.ImgNUmber.push(yiStack.currentImageIdIndex);
          this.ImgNUmber.push(chestStack.currentImageIdIndex);
          this.ImgNUmber.push(sanStack.currentImageIdIndex);
          this.ImgNUmber.push(siStack.currentImageIdIndex);
          this.ImgNUmber.push(wuStack.currentImageIdIndex);
          this.ImgNUmber.push(liuStack.currentImageIdIndex);
          this.ImgNUmber.push(qiStack.currentImageIdIndex);
          this.ImgNUmber.push(baStack.currentImageIdIndex);
          this.ImgNUmber.push(jiuStack.currentImageIdIndex);
          console.error("aaaaaaa", this.ImgNUmber);
          console.error(
            "chestStack.currentImageIdIndex",
            yiStack.currentImageIdIndex
          );
        });
        this.addTool();
      }, 10);
    },
    init() {
      this.focusElementIndex = 0;
      this.precess();
      this.lazyLoad();
      //this.lazyLoad();
      //setTimeout(() => {
      //}, 2000);
    },
    onImageRendered(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRendered = context;
      this.contextonImageRenderedqq = this.contextonImageRendered.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colordian == false){
        this.contextonImageRendered.putImageData(this.contextonImageRenderedqq,0,0);

      }else {
        for (let g = 0; g < this.pointMark.length; g++) {
          // console.log('this.pointMark[g]',this.pointMark[g])
          if (this.pointMark[g].length == 0) {
            continue;
          }
          if(this.pointMark[g] != null){
            const pointMarkList = this.pointMark[g];
            // console.log(pointMarkList);
            let firstPointIndex = pointMarkList[0];
            // console.log(firstPointIndex);
            if (firstPointIndex.length == 0) {
              firstPointIndex = pointMarkList[1];
            }
            for (let i = 0; i < pointMarkList.length - 1; i++) {
              ``

              this.drawPoint(context,pointMarkList[0], pointMarkList[1], 'yellow',1.5);

              //这里
              if (i == (pointMarkList.length - 2)) {
                if (pointMarkList[0].length > 1) {
                  // drawLine(context, newPoint.x, newPoint.y, firstPoint.x, firstPoint.y, instanceListary.polyColor[g], 1.5);
                }

              }
            }
          }
        }
      }

    },
    onImageRenderedLCC(e) {
      // alert(222);
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextq222 = context;
      // console.error('eventData.element',eventData.element);
      this.qqww = this.contextq222.getImageData(0,0,context.canvas.width,context.canvas.height);
      // console.error('this.qqww',this.qqww);
      if(this.colordian == false){
        this.contextq222.putImageData(this.qqww,0,0);

      }else {
        for (let g = 0; g < this.pointMarkLCC.length; g++) {
          // console.log('this.pointMark[g]',this.pointMark[g])
          if (this.pointMarkLCC[g].length == 0) {
            continue;
          }
          if(this.pointMarkLCC[g] != null){
            const pointMarkList = this.pointMarkLCC[g];
            // console.log(pointMarkList);
            let firstPointIndex = pointMarkList[0];
            // console.log(firstPointIndex);
            if (firstPointIndex.length == 0) {
              firstPointIndex = pointMarkList[1];
            }
            for (let i = 0; i < pointMarkList.length - 1; i++) {
              ``
              // console.error('pointMarkList[0]',pointMarkList[0]);
              // console.error('pointMarkList[1]',pointMarkList[1]);
              // console.error('context',context);
              this.drawPoint(context,pointMarkList[0], pointMarkList[1], 'yellow',1.5);

              //这里
              if (i == (pointMarkList.length - 2)) {
                if (pointMarkList[0].length > 1) {
                  // drawLine(context, newPoint.x, newPoint.y, firstPoint.x, firstPoint.y, instanceListary.polyColor[g], 1.5);
                }

              }
            }
          }
        }
      }
      //  var pointMark = [[[2440,2242],[2440,2243],[2440,2244],[2441,2244],[2441,2243],[2441,2242]],[[2385,2129],[2385,2130],[2385,2131],[2386,2132],[2387,2132],[2388,2132],[2389,2133],[2390,2133],[2391,2132],[2391,2131],[2391,2130],[2390,2129],[2389,2129],[2388,2129],[2387,2129],[2386,2129]],[[2278,2126],[2277,2127],[2277,2128],[2277,2129],[2277,2130],[2278,2131],[2279,2131],[2280,2131],[2281,2131],[2281,2130],[2281,2129],[2281,2128],[2280,2127],[2279,2126]],[[2431,2072],[2431,2073],[2431,2074],[2432,2075],[2433,2075],[2433,2074],[2433,2073],[2433,2072],[2432,2072]],[[2412,2072],[2412,2073],[2413,2073],[2413,2072]],[[2428,2061],[2428,2062],[2428,2063],[2428,2064],[2428,2065],[2429,2066],[2430,2066],[2431,2066],[2432,2066],[2433,2065],[2433,2064],[2433,2063],[2433,2062],[2432,2061],[2431,2061],[2430,2061],[2429,2061]],[[2522,1860],[2522,1861],[2522,1862],[2522,1863],[2523,1863],[2524,1862],[2524,1861],[2524,1860],[2523,1860]],[[2934,1415],[2934,1416],[2934,1417],[2934,1418],[2935,1418],[2936,1418],[2936,1417],[2936,1416],[2936,1415],[2935,1415]],[[3306,1359],[3305,1360],[3305,1361],[3306,1362],[3307,1362],[3308,1362],[3309,1362],[3309,1361],[3309,1360],[3309,1359],[3308,1359],[3307,1359]],[[2541,796],[2541,797],[2541,798],[2541,799],[2541,800],[2540,801],[2539,802],[2538,802],[2538,803],[2538,804],[2538,805],[2539,805],[2540,805],[2541,805],[2542,804],[2543,803],[2544,803],[2544,802],[2544,801],[2544,800],[2544,799],[2543,798],[2543,797],[2542,796]],[[2557,779],[2556,780],[2555,781],[2554,781],[2554,782],[2553,783],[2553,784],[2552,785],[2551,786],[2551,787],[2551,788],[2551,789],[2551,790],[2552,791],[2552,792],[2553,792],[2554,793],[2555,794],[2556,795],[2557,795],[2558,795],[2559,795],[2560,795],[2561,794],[2562,794],[2563,794],[2564,793],[2565,792],[2566,791],[2567,791],[2568,790],[2568,789],[2568,788],[2568,787],[2568,786],[2567,785],[2567,784],[2566,783],[2565,782],[2564,781],[2563,780],[2562,780],[2561,780],[2560,779],[2559,779],[2558,779]],[[2329,765],[2328,766],[2328,767],[2328,768],[2328,769],[2328,770],[2329,771],[2330,772],[2330,773],[2331,774],[2332,774],[2333,774],[2334,773],[2335,773],[2336,773],[2337,772],[2337,771],[2337,770],[2337,769],[2337,768],[2336,767],[2335,766],[2334,765],[2333,765],[2332,765],[2331,765],[2330,765]],[[2954,439],[2954,440],[2954,441],[2954,442],[2954,443],[2955,443],[2956,443],[2957,443],[2958,442],[2958,441],[2958,440],[2957,439],[2956,439],[2955,439]],[[3171,275],[3171,276],[3171,277],[3172,277],[3173,277],[3174,277],[3174,276],[3174,275],[3173,275],[3172,275]],[[2455,48],[2454,49],[2454,50],[2454,51],[2455,51],[2456,51],[2457,51],[2458,50],[2458,49],[2458,48],[2457,48],[2456,48]],[[2671,36],[2671,37],[2672,38],[2673,38],[2674,37],[2674,36],[2673,36],[2672,36]]];
      // console.error('pointMarkpointMark',instanceListary);

    },
    // onImageRenderedLCC(e) {
    //   console.error(e);
    //   const eventData = e.detail;
    //   const ctx = eventData.canvasContext;
    //   this.contextq222.putImageData(this.qqww,0,0);
    //   context.fillStyle = "yellow";
    //   context.fillRect(50, 50, 150, 100);
    //     //重新设置宽高为0会2全部清除
    //     // context.canvas.width = 0;
    //     // context.canvas.height = 0;
    // },
    onImageRenderedRMLO(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedRMLO = context;
      this.contextonImageRenderedRMLOqq = this.contextonImageRenderedRMLO.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colordian == false){
        this.contextonImageRenderedRMLO.putImageData(this.contextonImageRenderedRMLOqq,0,0);

      }else {
        for (let g = 0; g < this.pointMarkRMLO.length; g++) {
          // console.log('this.pointMark[g]',this.pointMark[g])
          if (this.pointMarkRMLO[g].length == 0) {
            continue;
          }
          if(this.pointMarkRMLO[g] != null){
            const pointMarkList = this.pointMarkRMLO[g];
            // console.log(pointMarkList);
            let firstPointIndex = pointMarkList[0];
            // console.log(firstPointIndex);
            if (firstPointIndex.length == 0) {
              firstPointIndex = pointMarkList[1];
            }
            for (let i = 0; i < pointMarkList.length - 1; i++) {
              ``

              this.drawPoint(context,pointMarkList[0], pointMarkList[1], 'yellow',1.5);

              //这里
              if (i == (pointMarkList.length - 2)) {
                if (pointMarkList[0].length > 1) {
                  // drawLine(context, newPoint.x, newPoint.y, firstPoint.x, firstPoint.y, instanceListary.polyColor[g], 1.5);
                }

              }
            }
          }
        }
      }

    },
    onImageRenderedRCC(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedRCC = context;
      this.contextonImageRenderedRCCqq = this.contextonImageRenderedRCC.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colordian == false){
        this.contextonImageRenderedRCC.putImageData(this.contextonImageRenderedRCCqq,0,0);
      }else {
        for (let g = 0; g < this.pointMarkRCC.length; g++) {
          // console.log('this.pointMark[g]',this.pointMark[g])
          if (this.pointMarkRCC[g].length == 0) {
            continue;
          }
          if(this.pointMarkRCC[g] != null){
            const pointMarkList = this.pointMarkRCC[g];
            // console.error('11111111',pointMarkList);
            let firstPointIndex = pointMarkList[0];
            // console.log(firstPointIndex);
            if (firstPointIndex.length == 0) {
              firstPointIndex = pointMarkList[1];
            }
            for (let i = 0; i < pointMarkList.length - 1; i++) {
              ``

              this.drawPoint(context,pointMarkList[0], pointMarkList[1], 'yellow',1.5);

              //这里
              if (i == (pointMarkList.length - 2)) {
                if (pointMarkList[0].length > 1) {
                  // drawLine(context, newPoint.x, newPoint.y, firstPoint.x, firstPoint.y, instanceListary.polyColor[g], 1.5);
                }

              }
            }
          }
        }
      }
    },
    onImageRenderedzhongkuai(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedzhongkuai = context;
      this.contextcontextonImageRenderedzhongkuaiqq = this.contextonImageRenderedzhongkuai.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colorquan == false){
        this.contextonImageRenderedzhongkuai.putImageData(this.contextcontextonImageRenderedzhongkuaiqq,0,0);
      }else {
        console.error('3333',this.newarray);
        this.newarray.forEach(element => {
          console.error('element',element)
          this.polygon(element,context);
        });
      }
    },
    onImageRenderedzhongkuaiLCC(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedzhongkuaiLCC = context;
      this.contextcontextonImageRenderedzhongkuaiLCCqq = this.contextonImageRenderedzhongkuaiLCC.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colorquan == false){
        this.contextonImageRenderedzhongkuaiLCC.putImageData(this.contextcontextonImageRenderedzhongkuaiLCCqq,0,0);
      }else {
        this.newarrayLCC.forEach(element => {
          this.polygon(element,context);
        });
      }
    },
    onImageRenderedzhongkuaiRCC(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedzhongkuaiRCC = context;
      this.contextcontextonImageRenderedzhongkuaiRCCqq = this.contextonImageRenderedzhongkuaiRCC.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colorquan == false){
        this.contextonImageRenderedzhongkuaiRCC.putImageData(this.contextcontextonImageRenderedzhongkuaiRCCqq,0,0);
      }else {
        this.newarrayRCC.forEach(element => {
          this.polygon(element,context);
        });
      }
    },
    onImageRenderedzhongkuaiRMLO(e) {
      const eventData = e.detail;
      const context = eventData.canvasContext;
      this.contextonImageRenderedzhongkuaiRMLO = context;
      this.contextcontextonImageRenderedzhongkuaiRMLOqq = this.contextonImageRenderedzhongkuaiRMLO.getImageData(0,0,context.canvas.width,context.canvas.height);
      if(this.colorquan == false){
        this.contextonImageRenderedzhongkuaiRMLO.putImageData(this.contextcontextonImageRenderedzhongkuaiRMLOqq,0,0);
      }else {
        this.newarrayRMLO.forEach(element => {
          this.polygon(element,context);
        });
      }
    },
    fullScreen() {
      if (this.isFullScreen()) {
        this.exitFullscreen();
      } else {
        this.launchFullscreen(document.body);
      }
    },
    launchFullscreen(element) {
      if (element.requestFullscreen) {
        element.requestFullscreen();
      } else if (element.mozRequestFullScreen) {
        element.mozRequestFullScreen();
      } else if (element.msRequestFullscreen) {
        element.msRequestFullscreen();
      } else if (element.webkitRequestFullscreen) {
        element.webkitRequestFullScreen();
      }
    },
    exitFullscreen() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      }
    },
    isFullScreen() {
      return !!(
        document.fullscreen ||
        document.mozFullScreen ||
        document.webkitIsFullScreen ||
        document.webkitFullScreen ||
        document.msFullScreen
      );
    },
  },
};
</script>

<style scoped lang="less">
.viewer {
  width: 100%;
  height: 100%;
  overflow: hidden;
  display: flex;
  flex-direction: column;

  .focus_bg {
    background-color: rgba(24, 170, 242, 0.1) !important;
    border: solid 1px #18aaf2 !important;
    border-radius: 4px !important;
    color: #18aaf2 !important;
  }

  .tool_focus_bottom {
    border-bottom: 1px solid #ffffff;
  }

  .tool_disable {
    opacity: 0.25;
    color: #409eff !important;
    background: transparent !important;
  }

  .active_layout {
    border: 1px solid #337ab7 !important;
  }

  .auto_layout1 {
    width: 100%;
    height: 100%;
  }

  .auto_layout2 {
    width: calc(50% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
  }

  .auto_layout2_1 {
    width: 100%;
    height: 50%;
  }

  .auto_layout4 {
    width: calc(50% - 2px);
    height: 50%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
  }
  .autocard_layout2 {
    width: calc(50% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout3 {
    width: calc(33.3% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout4 {
    width: calc(25% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout5 {
    width: calc(20% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout6 {
    width: calc(16.6% - 2px);
    height: 100%;
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout7 {
    width: 100%;
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout8 {
    width: calc(50% - 2px);
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout9 {
    width: calc(33.3% - 2px);
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout10 {
    width: calc(25% - 2px);
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout11 {
    width: calc(20% - 2px);
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout12 {
    width: calc(16.6% - 2px);
    height: calc(50% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout13 {
    width: 100%;
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout14 {
    width: calc(50% - 2px);
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout15 {
    width: calc(33.3% - 2px);
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout16 {
    width: calc(25% - 2px);
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout17 {
    width: calc(20% - 2px);
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout18 {
    width: calc(16.6% - 2px);
    height: calc(33.3% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout19 {
    width: 100%;
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout20 {
    width: calc(50% - 2px);
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout21 {
    width: calc(33.3% - 2px);
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout22 {
    width: calc(25% - 2px);
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout23 {
    width: calc(20% - 2px);
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout24 {
    width: calc(16.6% - 2px);
    height: calc(25% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout25 {
    width: 100%;
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout26 {
    width: calc(50% - 2px);
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout27 {
    width: calc(33.3% - 2px);
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout28 {
    width: calc(25% - 2px);
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout29 {
    width: calc(20% - 2px);
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout30 {
    width: calc(16.6% - 2px);
    height: calc(20% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout31 {
    width: 100%;
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .autocard_layout32 {
    width: calc(50% - 2px);
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout33 {
    width: calc(33.3% - 2px);
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout34 {
    width: calc(25% - 2px);
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout35 {
    width: calc(20% - 2px);
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }
  .autocard_layout36 {
    width: calc(16.6% - 2px);
    height: calc(16.6% - 2px);
    // float: left;
    display: inline-block;
    overflow-x: hidden;
    margin-top: -5px;
  }

  .auto_layout9 {
    width: calc(33.3% - 2px);
    height: 33.3%;
    display: inline-block;
  }
  .auto_layout11 {
    width: calc(33.3% - 2px);
    height: 100%;
    display: inline-block;
  }
  .auto_layout66 {
    width: calc(33.3% - 2px);
    height: 50%;
    display: inline-block;
  }
  .auto_layout22 {
    width: 100%;
    height: calc(33.3% - 2px);
    display: inline-block;
  }
  .auto_layout88 {
    width: calc(50% - 2px);
    height: calc(33.3% - 2px);
    display: inline-block;
  }
  .auto_layout14 {
    width: calc(100% - 2px);
    height: calc(24.5% - 2px);
    display: inline-block;
  }
  .auto_layout24 {
    width: calc(50% - 2px);
    height: calc(24.5% - 2px);
    display: inline-block;
  }
  .auto_layout34 {
    width: calc(50% - 2px);
    height: calc(24.5% - 2px);
    display: inline-block;
  }
  .auto_layout44 {
    width: calc(33.3% - 2px);
    height: calc(24.5% - 2px);
    display: inline-block;
  }
  .auto_layout41 {
    width: calc(25% - 2px);
    height: 100%;
    display: inline-block;
  }
  .auto_layout42 {
    width: calc(25% - 2px);
    height: calc(50% - 2px);
    display: inline-block;
  }
  .auto_layout43 {
    width: calc(25% - 2px);
    height: calc(33.3% - 2px);
    display: inline-block;
  }
  .auto_layout16 {
    width: calc(25% - 2px);
    height: calc(24.5% - 2px);
    display: inline-block;
  }
  .auto_layout99 {
    width: calc(24.5% - 2px);
    height: calc(33.3% - 2px);
    display: inline-block;
  }

  .tools {
    width: 100%;
    height: 40px;
    min-width: 800px;
    background-color: #051221;
    display: flex;
    flex-direction: row;

    .left {
      width: 120px;
      height: 40px;
      overflow: hidden;
      display: flex;
      flex-direction: row;
      background: #333333;
      overflow-y: scroll;

      span {
        flex: 1;
        text-align: center;
        line-height: 40px;
        color: #ffffff;
        font-size: 12px;
        cursor: pointer;
      }
    }

    .center {
      flex: 1;
      height: 40px;
      width: 300px;
      overflow: hidden;

      display: flex;
      flex-direction: row;

      .action_blur {
        background-color: #1a4372;
      }

      .normal_action {
        width: auto;
        height: 40px;
        display: flex;
        flex-direction: row;
        align-items: center;

        img {
          width: 25px;
          height: 25px;
          margin-bottom: 5px;
          cursor: pointer;
        }

        img:hover {
          // background-color: #1a4372;
        }
      }

      .separator {
        width: 1px;
        height: 40px;
        background: hsla(0, 0%, 78.4%, 0.2);
        margin: 0 5px;
      }
    }

    .right {
      width: 175px;
      height: 40px;
      overflow: hidden;
      text-align: right;
      padding: 10px;
      font-size: 12px;
      box-sizing: border-box;
      // background: #333;

      img {
        width: 40px;
        height: 40px;
        cursor: pointer;
      }
    }
  }

  .main {
    width: 100%;
    flex: 1;
    overflow: hidden;

    display: flex;
    flex-direction: row;

    .left {
      width: 120px;
      height: 100%;
      background-color: #051221;
      font-size: 14px;
      border-top: 1px solid #01303d;
      background: #333333;
      overflow-y: scroll;
      scrollbar-width: none;
      .left_content {
        background: #333;
        .left_listone {
          background: #444;
          padding: 5px 10px;
          box-sizing: border-box;
          color: #cccccc;
          font-weight: 400;
          display: flex;
          justify-content: space-between;
          cursor: pointer;
          span {
            font-size: 14px;
          }
        }
        .list_content {
          margin: 5px;
          box-sizing: border-box;
          display: flex;
          flex-wrap: wrap;
          height: 180px;
          transition: all ease 0.5s;
          justify-content: space-between;
          div {
            width: 44.5%;
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 4px 2px;
            flex-direction: column;
            // height: 40px;
            border: 1px solid transparent;
            color: #fff;
          }
        }
        .list_contentactive {
          // display: none;
          height: 0px;
          transition: height ease 0.5s;
          overflow: hidden;
          opacity: 0;
          margin: 0px;
        }
      }

      h3 {
        width: 100%;
        overflow: hidden;
        color: #ffffff;
        font-size: 12px;
        font-weight: normal;
        line-height: 30px;
        padding: 0 5px;
      }

      .layouts {
        // width: 100%;
        overflow: hidden;
        display: flex;
        flex-wrap: wrap;
        margin: 5px;
        transition: height ease 0.5s;
        height: 440px;
        justify-content: space-between;

        .layout {
          width: 44.5%;
          // height: 40px;
          color: #ffffff;
          cursor: pointer;
          display: inline-block;
          //   background: #000!important;
          display: flex;
          justify-content: center;
          margin: 4px 2px;
          align-items: center;
          border: 1px solid transparent;
          display: flex;
          flex-direction: column;

          img {
            width: 25px;
            height: 25px;
          }
        }

        .layout:hover {
          // background-color: #1a4372;
          background-color: rgba(24, 170, 242, 0.1);
          border: solid 1px #18aaf2;
          border-radius: 4px;
          color: #18aaf2;
        }

        .action_blur {
          background-color: rgba(24, 170, 242, 0.1) !important;
          border: solid 1px #18aaf2 !important;
          border-radius: 4px !important;
          color: #18aaf2 !important;
        }

        .normal_action {
          width: 45.5%;
          display: flex;
          flex-wrap: wrap;
          .layouter {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;
            flex-direction: column;
          }
          img {
            width: 25px;
            height: 25px;
            margin-bottom: 5px;
            margin-top: 5px;
            cursor: pointer;
          }

          img:hover {
            // background-color: #1a4372;
          }
        }
      }
      .layoutsactive {
        height: 0px;
        transition: height ease 0.5s;
        overflow: hidden;
        opacity: 0;
        margin: 0px;
      }
    }

    .center {
      position: relative;
      flex: 1;
      height: 100%;
      width: 300px;
      flex-shrink: 0;

      .layout {
        width: 100%;
        height: 100%;
        background: #000;
      }

      .dcm_layout {
        position: relative;
        overflow: hidden;
        background: #000000;
        border: 1px solid #222;

        .leftTop {
          position: absolute;
          left: 0;
          top: 0;
          color: #ffffff;
          user-select: none;
          padding-top: 5px;

          p {
            font-size: 12px;
            text-indent: 5px;
            line-height: 20px;
          }
        }

        .rightTop {
          position: absolute;
          right: 10px;
          top: 5px;
          color: #ffffff;
          user-select: none;

          p {
            font-size: 12px;
            text-indent: 5px;
            line-height: 20px;
            text-align: right;
          }
        }
        .bottomRight {
          position: absolute;
          right: 10px;
          bottom: 5px;
          color: #ffffff;
          user-select: none;

          p {
            font-size: 12px;
            text-indent: 5px;
            line-height: 20px;
            text-align: right;
          }
        }
      }

      .layout1 {
        width: 100%;
        height: 100%;
        border: 1px solid #337ab7;
      }

      .layout2 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;

        .layout2_child {
          flex: 1;
          height: 100%;
          border: 1px solid #222;
        }
      }

      .layout2_1 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: column;

        .layout2_1_child {
          width: 100%;
          flex: 1;
          border: 1px solid #222;
        }
      }

      .layout4 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .layout4_child {
          flex: 50%;
          height: 50%;
          border: 1px solid #222;
        }
      }

      .layout9 {
        width: 100%;
        height: 100%;
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;

        .layout9_child {
          flex-shrink: 0;
          flex: 33.3%;
          height: 33.3%;
          /*border: 1px solid #337ab7;*/
          border: 1px solid #222;
          overflow: hidden;
        }
      }
    }

    .right {
      width: 175px;
      height: 100%;
      background-color: #051221;
      font-size: 14px;
      border-top: 1px solid #01303d;
      padding: 10px;
      font-size: 12px;
      box-sizing: border-box;
      background: #333;
      padding-top: 0px;

      .dcm_count {
        color: #ffffff;
        font-size: 11px;
        text-align: center;
        margin: 5px 0;
      }

      .dcm_load_progress {
        color: #ffffff;
        font-size: 11px;
        text-align: center;
        margin: 5px 0;
      }

      .item_dcms {
        width: 100%;
        height: 100%;
        overflow-y: scroll;
        display: flex;
        flex-direction: column;
        align-items: center;
        scrollbar-width: none;

        .dcm {
          width: 100%;
          height: 75px;
          border: 1px solid #eee;
          cursor: pointer;
          position: relative;
          display: flex;
          align-items: center;
          // justify-content: center;
          padding: 5px;
          box-sizing: border-box;
          border-radius: 5px;
          margin: 10px auto;

          .title {
            width: 100%;
            overflow: hidden;
            color: #ffffff;
            text-align: center;
            margin-top: 3px;
            text-align: left;
          }

          img {
            width: 60px;
            height: 60px;
            object-fit: cover;
            margin-right: 10px;
            border-radius: 3px;
          }
        }
      }
    }
  }
}

.show {
  width: 100%;
  height: 300px;
}
.box_type {
  height: 100%;
}
/deep/.el-progress-bar__outer {
  border-radius: 3px !important;
}
/deep/.el-progress-bar__inner {
  border-radius: 3px !important;
}
.dcmactive {
  background: rgba(255, 255, 255, 0.25);
}
.el-col-12 {
  width: 100% !important;
}
.el-icon-caret-bottom {
  display: flex;
  align-items: center;
  justify-content: center;
}
.el-icon-caret-top {
  display: flex;
  align-items: center;
  justify-content: center;
}
.layoutss {
  // width: 100%;
  overflow: hidden;
  display: flex;
  flex-wrap: wrap;
  margin: 5px;
  transition: height ease 0.5s;
  height: 295px;
  justify-content: space-between;
}
.layoutsactives {
  height: 0px;
  transition: height ease 0.5s !important;
  overflow: hidden;
  opacity: 0;
  margin: 0px;
}
.Fullscreen {
  width: 45.5%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: solid 1px transparent;
  color: #fff;
}
.Fullscreen:hover {
  background-color: rgba(24, 170, 242, 0.1);
  border: solid 1px #18aaf2;
  border-radius: 4px;
  color: #18aaf2;
  // background-color: #1a4372;
}
.normal_action {
  width: auto;
  // height: 40px;
  display: flex;
  flex-direction: row;
  align-items: center;
  .layouter {
    border: solid 1px transparent;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
  }
  img {
    width: 25px;
    height: 25px;
    cursor: pointer;
    margin: 5px;
    margin-bottom: 5px;
  }
  //显示功能中间的
  img:hover {
    // background-color: #1a4372;
  }
}
.normal_action .layouter:hover {
  background-color: rgba(24, 170, 242, 0.1);
  border: solid 1px #18aaf2;
  border-radius: 4px;
  color: #18aaf2;
}
.action_blurs {
  background-color: rgba(24, 170, 242, 0.1) !important;
  border: solid 1px #18aaf2 !important;
  border-radius: 4px !important;
  color: #18aaf2 !important;
}
/*修改滚动条样式*/
div::-webkit-scrollbar {
  width: 0px;
  height: 0px;
  /**/
}
div::-webkit-scrollbar-track {
  background: rgb(255, 255, 255);
}
div::-webkit-scrollbar-thumb {
  background: #ffffff;
  border-radius: 10px;
}
div::-webkit-scrollbar-thumb:hover {
  background: rgb(255, 255, 255);
}
div::-webkit-scrollbar-corner {
  background: #ffffff;
}
.Adjustable {
  width: auto !important;
}
.nameDcm {
  font-size: 12px !important;
  cursor: pointer;
}
.mprstyle {
  height: 60px;
  width: 44.5%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  border: 1px solid transparent;
  color: #fff;
}
.mprstyle:hover {
  background-color: rgba(24, 170, 242, 0.1);
  border: solid 1px #18aaf2;
  border-radius: 4px;
  color: #18aaf2;
}
.el-dropdown {
  width: 44.5% !important;
}
.titleover {
  width: 88px !important;
  overflow: hidden !important;
  display: inline-block !important;
  text-overflow: ellipsis !important;
  white-space: nowrap !important;
}
.layout_box {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  width: 44.5% !important;
  margin: 4px 2px;
  border: 1px solid transparent;
  cursor: pointer;
}

.Dcmlayout {
  color: #fff;
  margin-top: -3px !important;
}
.layout_box:hover {
  background-color: rgba(24, 170, 242, 0.1);
  border: solid 1px #18aaf2;
  border-radius: 4px;
  color: #18aaf2 !important;
}
.layout_box:hover .Dcmlayout {
  color: #18aaf2 !important;
}
.squared {
  width: 126px;
  height: auto;
  padding: 5px;
  box-sizing: border-box;
  border-radius: 5px;
}
.practicing_box {
  display: flex;
  flex-wrap: wrap;
}
.practicing {
  width: 26px;
  height: 26px;
  background: rgb(85, 85, 85);
  border-radius: 2px;
  margin-left: 2px;
  margin-top: 2px;
}
.practicing_one {
  background: #ccc !important;
}
/deep/.poppover {
  min-width: auto !important;
}
.layoutgun {
  margin: 0px !important;
  display: flex !important;
  justify-content: flex-end !important;
}
.showQuadrangle {
  display: none;
}
.center_card {
  background: #fff;
  border-radius: 10px;
  padding-left: 10px;
  padding-right: 10px;
  padding-top: 5px;
  padding-bottom: 5px;
  box-sizing: border-box;
  border: 1px solid rgba(255, 255, 255, 0.25);
  position: absolute;
  font-size: 12px;
  font-weight: 500;
}
.center_card:hover {
  background: #000;
  color: #fff;
}
.cardDcm_layout {
  position: relative;
  overflow: hidden;
  background: #000000;
  border: 1px solid #222;
}
.auto_layout1 {
  width: 100%;
  height: 100%;
}
.cardLayoutBox {
  display: flex;
}
.comUrlPath {
  width: 150px;
  height: 400px;
  overflow-y: scroll;
  background: #333;
  padding-left: 10px;
  padding-right: 10px;
  padding-bottom: 10px;
  box-sizing: border-box;
  // margin-left:px;
}
.comUrlList {
  display: flex;
  border-radius: 10px;
  border: 1px solid #fff;
  padding: 10px;
  box-sizing: border-box;
  margin-top: 10px;
}
.leftCom {
  width: 40px;
  height: 60px;
  margin-right: 10px;
}
.rightCom p {
  color: #fff;
  font-size: 12px;
}
.cardCanvasLeft {
  position: absolute;
  left: 0px;
  top: 0px;
  // width: 500px;
  // height: 20px;
  // background: #18aaf2;
  font-size: 12px;
}
.cardCanvasLeft p:first-child {
  margin-top: 2px;
}
.cardCanvasLeft p {
  color: #fff;
  font-size: 12px;
}
.cardCanvasRight {
  position: absolute;
  right: 0px;
  top: 0px;
  // width: 500px;
  // height: 20px;
  // background: #18aaf2;
  font-size: 12px;
}
.cardCanvasRight p:first-child {
  margin-top: 2px;
}
.cardCanvasRight p {
  color: #fff;
  font-size: 12px;
}
.cardCanvasRightBottom {
  position: absolute;
  right: 0px;
  bottom: 0px;
  // width: 500px;
  // height: 20px;
  // background: #18aaf2;
  font-size: 12px;
}
.cardCanvasRightBottom p:first-child {
  margin-top: 2px;
}
.cardCanvasRightBottom p {
  color: #fff;
  font-size: 12px;
}
.cardtool {
  display: flex;
  justify-content: space-between;
}
.cardtool_left {
  display: flex;
}
.cardtool_left div {
  margin-right: 10px;
  cursor: pointer;
}
.cardtool_right {
  margin-right: 10px;
  cursor: pointer;
}
.cardLayoutBoxs {
  width: 175px;
  display: flex;
  flex-wrap: wrap;
}
.cardLayoutBoxs .cardItembox {
  width: 26px;
  height: 26px;
  background: #555555;
  border-radius: 2px;
  margin-left: 2px;
  margin-top: 2px;
}
/deep/.carBoxBox .el-dialog__header {
  display: none;
}
/deep/.carBoxBox .el-dialog__body {
  padding: 2px;
  // background: #000;
}
.dayinstyle {
  width: 51px;
  height: 50px;
  border: 1px solid transparent;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.dayinstyleactive {
  width: 51px;
  height: 50px;
  border: 1px solid #18aaf2;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
}
.dayinstyle span {
  font-size: 12px;
  color: #fff;
}
.dayinstyleactive span {
  font-size: 12px;
  color: #18aaf2;
}
.dayinstyle img {
  padding-top: 2px;
  width: 25px;
  height: 25px;
  margin-bottom: 5px;
}
.dayinstyleactive img {
  padding-top: 2px;
  width: 25px;
  height: 25px;
  margin-bottom: 5px;
}
.progressBox {
  position: absolute;
  left: 0px;
  bottom: -5px;
  z-index: 999;
  width: 100%;
}
/deep/.progressBox .el-progress__text {
  display: none !important;
}
/deep/.progressBox .el-progress-bar {
  padding-right: 0px !important;
}
/deep/.progressBox .el-progress-bar__inner {
  background-color: #009b43 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/usui/viewer.vue